var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileTousALaventureAvecSolEtAero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1120,
    height: 720,
    viewBox: "0 0 1120 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M36.252,4.77c21.072,7.206,41.43,6.07,64.758,7.2,31.4,1.522,60.142,6.582,91.748,3.4C219.034,12.726,248.4,7.8,275.036,9.6c22.808,1.544,20.646,12.79,26.788,26.21-.326-10-1.362-19.6,11.418-23.788,12.738-4.174,42.84-3.59,56.8-3.628,15.744-.044,31.536-.192,47.278,0,19.95.248,33.794,5.5,52.656,7.3,6.51.624,21.154-2.264,26.742-.116,8.016,3.08,4.964,10.16,13,13.244a11.555,11.555,0,0,1,6.492-11.642c8.85-4.548,6.652.658,13.78-.294C551.636,14,570.114,10.812,592.9,10.808q26.412,0,52.822,0c15.888,0,34.98-3.43,49.816-2.8,26,1.108,25.746,21.956,34.13,32.046.018-8.588-6.484-33.278,13.046-35.128,2.844,5.886,3.346,12.574,8.5,17.556C754.052-4.006,853.278,6.4,878.684,7.23,913.1,8.358,955.6,1.47,985.722,10.172c6.66,1.924,19.64,4.192,24.722,5.746,12.912,3.948,11.768,11.524,22.678,16.576-.844-7.564,5.38-20.3,16.366-24.714,8.424-3.382,22.508-.754,35.256-.412a51.915,51.915,0,0,1-3.386,11.656c41.986,3.548,15.5,15.766,18.844,32.956,6.376,32.808,6.382,68.464,3.588,102.2-17.442,1.244-32.67.674-45.938,9.942,35.73,1.1,31.494,2.944,34.778,22.938,1.7,10.352,1.768,20.394,2.3,30.6.558,10.774,8.4,19.356,5.108,29.846-2.34,7.448-8.092,9.94-6.35,18.28.644,3.08,5.526,7.988,6.676,11.682,5.8,18.614,1.942,39.03,7.594,58.2,3.342,11.338,12.6,31.52-1.594,39.038-6.528,3.46-27.374,2.632-36.074,4.386-10.844,2.188-23.846,5.508-31.106,10.8,15.058,3.244,28.57-2.284,43.54-.812a4.9,4.9,0,0,1,1.628,1.98c-11.762,1.994-22.1,7.3-31.456,12.15,12.954.882,46.916-5.83,55.124,1.92,3.982,3.76,3.618,24.884,3.514,30.664-35.348,1.2-66.186,3.7-98.826,14.614,19.942,1,78.134-14.81,94.178,1.344,6.994,7.042-3.21,16.344-2.974,23.13.544,15.574,13.792,26.686,8.944,43-6.776,22.806-13.822,36.312-6.11,58.646,8.214,23.784,5.262,47.086,4.89,70.882-.292,18.664,11.534,39.782,7.542,57.832-11.968-1.658-27.612-4.224-40.156-2.228-12.684,2.018-21.65,7.112-35.336,8.232-16.758,1.372-34.148-1.4-50.916-1.748-54.034-1.11-133.78,22.844-169.6-10.022-1.9,4.748-2.886,10.07-.534,14.4-81.426-2.664-162.734,19.9-239.032-7.942-30.552,17.074-83.534-.254-115.108,11.406-3.678-15.542-21.366-25.31-27.478-39.838.708,11.976,8.376,28.492-7.09,32.722-3.7,1.012-19.632.892-25.282,1.484-18.67,1.96-35.412,4.45-54.5,4.506-17.488.052-36.034,1.838-53.238.646-25.892-1.792-48.94-11.836-75.52-11.436-21.542.322-43.432,9.566-64.646,8.362-13.34-.758-24.268-7.872-38.08-3.568-3.542-5.364-3.02-12.078-7.722-15.822-.836,6.438-2.384,14.368-9.976,18.39-13.044-8.182-25.98,3.836-40.492,3.5-8.748-.2-15.738-6.1-24.412-7.208-8.978-1.144-17.688,2.156-27.174.19-1.5-11.172,16.956-16.524,10.954-28.624-2.08-4.192-10.732-7.172-14.128-12.19-5.6-8.266-.674-14.544-.162-22.444,3.164-48.978-6.464-99.016.22-148.536,15.2.066,25.886-13.146,31.462-20.622-10.708.162-20.764,1.562-29.626-2.03,7.45-13.414-.8-27.132-2.262-40.668-.526-4.868-2.146-21.25,2.042-26.078,4.344-5.006,16.572-5.164,20.956-13.2-9.446.606-18.076.682-25.01-3.244,7.376-4.736,1.894-7.91,3.736-12.394,2.148-5.226,9.032-8.88,3.542-14.6,12.274-5.99,51.668-12.268,55.312-23.548,3.334-10.32-45.606-12.132-56.91-16.662,2.62-.358,7.046-2.63,10.028-3.112-1.872-1.234-3.026-3.566-5.346-4.9,8.388-9.616,1.848-24.408,1.264-34.71-1.378-24.34,1.656-48.34-3.3-72.5-2.982-14.548-1.516-28.77-2.148-43.37C12.918,152,5.874,138.866,5.5,125.118c-.38-13.83,25.108-36.592,12.162-48.894,2.554-.748,4.75-2.4,7.24-3.154C-2.448,59.106,70.192,57.116,83.86,52.06c-22.284-1.286-45.422,4.482-66.544-1.976C8.882,47.506.342,44.822,0,38.03c-.276-5.592,11.662-3.976,10.242-11.316,5.9-2.938,6.156-6.822,1.676-10.892C21.22,10.246,24.812,4.968,36.348,0,35.236,2.628,33.292,5.022,36.252,4.77Z",
    transform: "translate(220 823)",
    fill: "#dfe9f0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 1119.999,
    height: 720,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    transform: "translate(-220 -823)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(220 823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M36.252,4.77c21.072,7.206,41.43,6.07,64.758,7.2,31.4,1.522,60.142,6.582,91.748,3.4C219.034,12.726,248.4,7.8,275.036,9.6c22.808,1.544,20.646,12.79,26.788,26.21-.326-10-1.362-19.6,11.418-23.788,12.738-4.174,42.84-3.59,56.8-3.628,15.744-.044,31.536-.192,47.278,0,19.95.248,33.794,5.5,52.656,7.3,6.51.624,21.154-2.264,26.742-.116,8.016,3.08,4.964,10.16,13,13.244a11.555,11.555,0,0,1,6.492-11.642c8.85-4.548,6.652.658,13.78-.294C551.636,14,570.114,10.812,592.9,10.808q26.412,0,52.822,0c15.888,0,34.98-3.43,49.816-2.8,26,1.108,25.746,21.956,34.13,32.046.018-8.588-6.484-33.278,13.046-35.128,2.844,5.886,3.346,12.574,8.5,17.556C754.052-4.006,853.278,6.4,878.684,7.23,913.1,8.358,955.6,1.47,985.722,10.172c6.66,1.924,19.64,4.192,24.722,5.746,12.912,3.948,11.768,11.524,22.678,16.576-.844-7.564,5.38-20.3,16.366-24.714,8.424-3.382,22.508-.754,35.256-.412a51.915,51.915,0,0,1-3.386,11.656c41.986,3.548,15.5,15.766,18.844,32.956,6.376,32.808,6.382,68.464,3.588,102.2-17.442,1.244-32.67.674-45.938,9.942,35.73,1.1,31.494,2.944,34.778,22.938,1.7,10.352,1.768,20.394,2.3,30.6.558,10.774,8.4,19.356,5.108,29.846-2.34,7.448-8.092,9.94-6.35,18.28.644,3.08,5.526,7.988,6.676,11.682,5.8,18.614,1.942,39.03,7.594,58.2,3.342,11.338,12.6,31.52-1.594,39.038-6.528,3.46-27.374,2.632-36.074,4.386-10.844,2.188-23.846,5.508-31.106,10.8,15.058,3.244,28.57-2.284,43.54-.812a4.9,4.9,0,0,1,1.628,1.98c-11.762,1.994-22.1,7.3-31.456,12.15,12.954.882,46.916-5.83,55.124,1.92,3.982,3.76,3.618,24.884,3.514,30.664-35.348,1.2-66.186,3.7-98.826,14.614,19.942,1,78.134-14.81,94.178,1.344,6.994,7.042-3.21,16.344-2.974,23.13.544,15.574,13.792,26.686,8.944,43-6.776,22.806-13.822,36.312-6.11,58.646,8.214,23.784,5.262,47.086,4.89,70.882-.292,18.664,11.534,39.782,7.542,57.832-11.968-1.658-27.612-4.224-40.156-2.228-12.684,2.018-21.65,7.112-35.336,8.232-16.758,1.372-34.148-1.4-50.916-1.748-54.034-1.11-133.78,22.844-169.6-10.022-1.9,4.748-2.886,10.07-.534,14.4-81.426-2.664-162.734,19.9-239.032-7.942-30.552,17.074-83.534-.254-115.108,11.406-3.678-15.542-21.366-25.31-27.478-39.838.708,11.976,8.376,28.492-7.09,32.722-3.7,1.012-19.632.892-25.282,1.484-18.67,1.96-35.412,4.45-54.5,4.506-17.488.052-36.034,1.838-53.238.646-25.892-1.792-48.94-11.836-75.52-11.436-21.542.322-43.432,9.566-64.646,8.362-13.34-.758-24.268-7.872-38.08-3.568-3.542-5.364-3.02-12.078-7.722-15.822-.836,6.438-2.384,14.368-9.976,18.39-13.044-8.182-25.98,3.836-40.492,3.5-8.748-.2-15.738-6.1-24.412-7.208-8.978-1.144-17.688,2.156-27.174.19-1.5-11.172,16.956-16.524,10.954-28.624-2.08-4.192-10.732-7.172-14.128-12.19-5.6-8.266-.674-14.544-.162-22.444,3.164-48.978-6.464-99.016.22-148.536,15.2.066,25.886-13.146,31.462-20.622-10.708.162-20.764,1.562-29.626-2.03,7.45-13.414-.8-27.132-2.262-40.668-.526-4.868-2.146-21.25,2.042-26.078,4.344-5.006,16.572-5.164,20.956-13.2-9.446.606-18.076.682-25.01-3.244,7.376-4.736,1.894-7.91,3.736-12.394,2.148-5.226,9.032-8.88,3.542-14.6,12.274-5.99,51.668-12.268,55.312-23.548,3.334-10.32-45.606-12.132-56.91-16.662,2.62-.358,7.046-2.63,10.028-3.112-1.872-1.234-3.026-3.566-5.346-4.9,8.388-9.616,1.848-24.408,1.264-34.71-1.378-24.34,1.656-48.34-3.3-72.5-2.982-14.548-1.516-28.77-2.148-43.37C12.918,152,5.874,138.866,5.5,125.118c-.38-13.83,25.108-36.592,12.162-48.894,2.554-.748,4.75-2.4,7.24-3.154C-2.448,59.106,70.192,57.116,83.86,52.06c-22.284-1.286-45.422,4.482-66.544-1.976C8.882,47.506.342,44.822,0,38.03c-.276-5.592,11.662-3.976,10.242-11.316,5.9-2.938,6.156-6.822,1.676-10.892C21.22,10.246,24.812,4.968,36.348,0,35.236,2.628,33.292,5.022,36.252,4.77Z",
    transform: "translate(0)",
    fill: "#dfe9f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(284.377 381.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M538.949,524.675c-11.694-40.187-43.839-75.982-86.358-96.387a232.476,232.476,0,0,0-5.569-26.664c-1.886-7.074-3.868-13.385-5.921-18.847l6.576-2.273-1.867-6.273c-.4-1.362-.857-2.651-1.388-4.07l-.456-1.179-2.588-6.329-.38.129a46.3,46.3,0,0,0-24.106-20.9c-.185-.456-.385-.9-.594-1.341l-.636-1.329a80.435,80.435,0,0,0-5.958-10.942c-3.777-5.487-3.38-12.4-2.922-20.409l.141-2.44c.369-6.287.784-13.413.174-19.883-1.388-14.639-4.695-31.2-18.7-43.015-6.336-5.345-11.313-7.626-16.647-7.626-.484,0-.963.021-1.449.059-6.139-5.129-13.617-7.633-22.734-7.633a69.269,69.269,0,0,0-11.44,1.066,64.62,64.62,0,0,0-30.614,14.2c-14.432,12.177-19.768,30.4-21.708,43.552a104.931,104.931,0,0,0-.942,21.175c.073,1.3.174,2.63.275,3.974.531,7.036,1.033,13.681-2.064,18.18-.749,1.087-1.571,2.116-2.391,3.15a42.277,42.277,0,0,0-5.3,7.924,24.322,24.322,0,0,0-1.029,2.506,46.079,46.079,0,0,0-21.375,19.738l-.406-.136-2.414,5.94s-.512,1.322-.662,1.724c-.472,1.263-.928,2.553-1.332,3.915l-.688,2.311c-1.4,1.263-3.591,3.154-6.074,5.291-2.889,2.489-6.285,5.414-9.6,8.361-.054-.094-.11-.185-.167-.277l.881-.965-14.1-24.933,3.962-9.8a10.217,10.217,0,0,0,1.35-3.415l1.651-8.485a10.235,10.235,0,0,0-8.084-11.99,10.313,10.313,0,0,0-1.954-.188,10.21,10.21,0,0,0-6.78,2.577l-3.166-8.152c-1.82-4.7-6.01-7.858-10.423-7.858a9.209,9.209,0,0,0-2.785.427,10.2,10.2,0,0,0-14.322,3.629,10.236,10.236,0,0,0-7.551,7.692,10.244,10.244,0,0,0-4.967,12.866l11.947,30.656a14.256,14.256,0,0,0,6.914,7.56l4.951,28.721,6.492-.606c.6,1.162,1.219,2.391,1.862,3.654,1.884,3.7,3.948,7.758,5.9,11.473a16.175,16.175,0,0,0-2.095,6.919c-.747,10.743,9.049,19.881,22.3,20.8.7.049,1.4.073,2.081.073,12.3,0,22.114-7.506,22.873-17.483,10.115-4.829,22.2-12.619,34.618-22.347q1.885-1.473,3.671-2.929a67.836,67.836,0,0,0,9.43,27.15l4.328,47.871h-.068a9.469,9.469,0,0,0-3.995.878l-.582.268-13.57-29.4a14.824,14.824,0,1,0-20.555,9.488l13.568,29.4-.585.27a9.569,9.569,0,0,0-4.662,12.675l.434.937a9.581,9.581,0,0,0,6.853,5.367,10.237,10.237,0,0,0,.571,7.142,9.986,9.986,0,0,0,5.923,5.275l10.583,22.392c-.232,4.617-.352,9.329-.352,14.035a199.669,199.669,0,0,0,1.5,25.943c-5.8,5.153-9.355,13.589-9.355,22.812,0,11.388,5.5,21.523,13.676,25.795-.1,2.663-.15,5.522-.15,8.624a202.658,202.658,0,0,0,1.437,23.8l-1.4.449,4.375,42.2q-.905.775-1.792,1.524c-55.488,6.733-63.847,21.638-63.847,29.989,0,25.8,71.5,32.613,109.3,32.613s109.3-6.816,109.3-32.613c0-8.342-8.34-23.232-63.72-29.973q-.895-.761-1.808-1.541l4.38-42.2-1.4-.449a202.655,202.655,0,0,0,1.44-23.8c0-3.1-.049-5.961-.153-8.627,8.18-4.272,13.674-14.406,13.674-25.792,0-9.223-3.556-17.661-9.352-22.812a199.426,199.426,0,0,0,1.5-25.943v0a181.791,181.791,0,0,0,39.83,4.467h0c36.448,0,70.294-11.3,95.3-31.826a13.764,13.764,0,0,0,3.589-4.582l1.179-2.384ZM348.235,710.095q-1.148-.007-2.3-.007c-.735,0-1.465,0-2.2.007l-.491-55.511q.039-.715.073-1.43l5.376,5Z",
    transform: "translate(-162.644 -198.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(6.842 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(284.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M394.772,789.043c-18.054,0-108.113-1.285-108.113-26.673,0-4.385,0-17.448,55.645-23.855q4.185-42.441,8.262-84.893c-11.2-.155-19.587-2.076-27.751-6.329a20.268,20.268,0,0,1-5.395-3.253l-2.316-2.05,0-3.1c-.016-13.951-.3-28.359-.566-42.294-.24-12.29-.486-25-.545-37.065-.035-3.037-.035-6.106-.035-9.174v-.77l-2.382,1.4-3.046-7.253c-2.158-5.143-3.814-9.542-5.2-13.843-6.362-19.571-9.221-38.858-8.492-57.313.369-19.5,6.327-41.415,16.344-59.974a202.7,202.7,0,0,1,15.959-24.855l1.1-1.513c1.207-1.67,2.56-3.539,4.105-5.348a48.243,48.243,0,0,1,18.448-18.523l13.434-7.539,8.075-4.545c-7.09-5.273-12.859-13.253-17.2-23.808-7.551-1.635-14.066-7.894-17.208-16.861-3.234-9.221-1.62-18.136,4.108-22.716a15.63,15.63,0,0,1,1.653-1.158,37.319,37.319,0,0,1-.892-4.434c-.24-2.036-1.3-11.842-1.766-19.007a40.282,40.282,0,0,1,4.1-20.787,29.165,29.165,0,0,1,8.432-10.414c9.113-6.785,42.592-15.879,64.342-15.879,8.958,0,15.444,1.461,19.834,4.462,14.251,9.747,10.851,25.964,5.735,35.978,3.149,5.388,7.008,15.621,4.444,31.164l.1.077c5.726,4.58,7.337,13.5,4.1,22.72-3.107,8.864-9.51,15.08-16.95,16.8-3.6,9.117-8.286,16.334-13.988,21.534v3.337l20.226,11.358a48.32,48.32,0,0,1,16.971,15.98c.378.308.813.7,1.327,1.2.639.62,1.329,1.329,2.041,2.161.2.223.326.378.437.517l.176.2.688.949a36.365,36.365,0,0,1,2.255,3.356l.388.625a89.31,89.31,0,0,1,4.653,9.185c1.35,3.051,2.654,6.327,3.87,9.726a10.016,10.016,0,0,1,7.346-3.333l.606.021,55.97,3.716a9.031,9.031,0,0,1,6.618,3.586,10.041,10.041,0,0,1,1.675,8.2L538.9,453.108a9.7,9.7,0,0,1,2.358,2.231,10.971,10.971,0,0,1,1.809,8.965,12.807,12.807,0,0,1-.719,2.276,11.377,11.377,0,0,1,.411,6.4,12.727,12.727,0,0,1-2.027,4.639,11.724,11.724,0,0,1-.195,3.91A12.579,12.579,0,0,1,536.926,488a12.1,12.1,0,0,1-.225,1.491,11.465,11.465,0,0,1-7.609,8.6l-2.337,10.728a10.543,10.543,0,0,1-10.017,8.507l-.606-.021-5.449-.362a45.024,45.024,0,0,1-4.979,4.178,33.059,33.059,0,0,1-6.818,3.8,27.419,27.419,0,0,1-10.273,2.046c-.308,0-.615-.007-.93-.019a25.537,25.537,0,0,1-9.474-2.234c.12,7.988.176,16.661.176,26.877l-.014,9.141c-.047,11.557-.16,23.2-.268,34.914-.134,14.007-.268,28.489-.294,42.839v4.169l-3.178,2.029c-7.856,5.017-18.422,7.985-32.169,9.012q4.129,42.627,8.3,85.245c52.113,6.55,52.115,19.148,52.115,23.427C502.883,787.758,412.823,789.043,394.772,789.043Zm0-53.344q2.66,0,5.287.028c-.829-31.9-1.367-57.369-1.712-81.1q-1.969.046-3.941.075c-.329,23.66-.855,49.168-1.677,81Q393.747,735.7,394.772,735.7Z",
    transform: "translate(-286.659 -215.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(14.942 6.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0 132.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(25.565 392.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M321.962,454.15c4.756.256,9.82.552,13.49-1.393v-3.114l-14.233-1.771Z",
    transform: "translate(-280.558 -432.804)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M358.8,451.424c-25.287,6.717-44.083,7.527-54.558,3.657l-.331-3.96,54.481-4.57Z",
    transform: "translate(-303.903 -434.585)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M358.515,454.918c-7.985,4.911-50.117,7.79-54.6,3.072-.221-2.717,4.171-5.655,12.112-8.845.787-.313,1.6-.625,2.464-.951.594-.223,1.217-.444,1.855-.681.829-.3,1.677-.594,2.553-.893h.014c.594-.207,1.217-.416,1.839-.622h.016c.86-.282,1.75-.564,2.67-.86,2.2-.7,4.512-1.4,6.961-2.109C355.636,436.857,358.158,450.54,358.515,454.918Z",
    transform: "translate(-303.907 -441.456)",
    fill: "#661615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(110.344 392.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M353.5,454.15c-4.758.256-9.82.552-13.493-1.393v-3.114l14.235-1.771Z",
    transform: "translate(-340.004 -432.804)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M340,451.424c25.29,6.717,44.083,7.527,54.558,3.657l.333-3.96-54.483-4.57Z",
    transform: "translate(-340.004 -434.585)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M340.127,454.918c7.983,4.911,50.117,7.79,54.6,3.072.223-2.717-4.171-5.655-12.109-8.845-.787-.313-1.6-.625-2.464-.951-.594-.223-1.217-.444-1.855-.681-.831-.3-1.677-.594-2.553-.893h-.014c-.594-.207-1.216-.416-1.841-.622h-.014c-.862-.282-1.752-.564-2.67-.86-2.2-.7-4.512-1.4-6.961-2.109C343.006,436.857,340.482,450.54,340.127,454.918Z",
    transform: "translate(-339.838 -441.456)",
    fill: "#661615"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M432.873,372.638a12.937,12.937,0,0,0-1.959-1.174,13.366,13.366,0,0,0-17.838,6.25l-.061.117s-.265.549-.756,1.588-1.247,2.553-2.2,4.422c-.965,1.886-2.168,4.112-3.577,6.531a67.132,67.132,0,0,1-4.66,6.975,80.949,80.949,0,0,1-3.993-11.473c-1.292-4.585-2.433-9.484-3.516-14.439-1.085-4.972-2.095-10.019-3.088-15.019-1.01-5.031-1.945-9.913-3.041-14.961-1.113-4.941-2.285-9.7-3.577-14.2-.045-.134-.075-.282-.12-.416-1.245-4.333-2.522-8.4-3.859-12.154-1.35-3.889-2.76-7.436-4.155-10.58a80.6,80.6,0,0,0-4.185-8.3c-.756-1.217-1.35-2.24-2.151-3.3-.193-.237-.371-.489-.535-.712l-.251-.34c-.089-.1-.148-.193-.326-.385a24.083,24.083,0,0,0-1.663-1.766,10.772,10.772,0,0,0-1.158-1.01c-.193-.148-.341-.254-.474-.357a.325.325,0,0,1-.073-.059c-.209-.134-.312-.207-.312-.207a8.676,8.676,0,0,0-10.625,13.711l.207.178a4.137,4.137,0,0,1,.371.3c.12.106.282.223.46.371.31.223.073.15-.031.12a.751.751,0,0,1-.3-.237.113.113,0,0,1,.028.059l.089.148c.061.106.134.209.209.326.268.357.639,1.13,1.052,1.855a68.492,68.492,0,0,1,2.821,6.546c1.01,2.687,2.078,5.862,3.086,9.422,1.055,3.518,2.034,7.45,2.969,11.607.951,4.169,1.766,8.622,2.553,13.223.712,4.542,1.409,9.6,2.123,14.662q.557,4.03,1.158,8.147c.371,2.45.742,4.913,1.141,7.391.831,5.254,1.766,10.566,2.938,15.9a96.949,96.949,0,0,0,4.883,16.37,41.352,41.352,0,0,0,3.013,5.9,29.825,29.825,0,0,0,2.271,3.206,22.535,22.535,0,0,0,5.55,4.927,18.878,18.878,0,0,0,9.1,2.807,20.462,20.462,0,0,0,8.37-1.529,26.238,26.238,0,0,0,5.371-3,41.6,41.6,0,0,0,6.5-5.89c1.66-1.841,3.072-3.577,4.289-5.226,1.275-1.691,2.374-3.279,3.384-4.777,1.942-2.938,3.516-5.491,4.749-7.6s2.165-3.77,2.774-4.9c.625-1.127.965-1.722.965-1.722.1-.207.237-.46.341-.667A13.347,13.347,0,0,0,432.873,372.638ZM404.2,401.279a1.771,1.771,0,0,1-.268-.3C404.366,401.293,404.349,401.413,404.2,401.279Z",
    transform: "translate(-214.087 -258.846)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M450.641,419.829l-41.366-70.141H332.492L301.7,419.829v37.716c12.391,10.982,102.786,12.955,148.941,0Z",
    transform: "translate(-281.317 -172.967)",
    fill: "#5b7234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M401.114,288.619l-20.548-13.887c-.6,9.082-4.617,16.792-16.656,18.909-10.679-1.8-16.231-10.115-17.145-19.2l-20.057,14.176c-12.948,41.025-16.844,86.788-15.867,135.1,17.873,3.53,37.564,26.2,53.069,26.135,15.508.066,35.2-22.605,53.071-26.135C416.021,373.131,411.918,326.577,401.114,288.619Z",
    transform: "translate(-269.182 -274.443)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(41.639 149.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M363.839,410.388a131.1,131.1,0,0,1-19.327-.845,34.826,34.826,0,0,1-29.914-27.5A204.009,204.009,0,0,1,310.77,338c18.185,5.193,35.948,8.544,53.069,9.113,17.124-.568,34.886-3.92,53.071-9.113a204.006,204.006,0,0,1-3.828,44.043,34.826,34.826,0,0,1-29.914,27.5A131.117,131.117,0,0,1,363.839,410.388Z",
    transform: "translate(-310.751 -338.002)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(9.537 2.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M317.81,350.521h-3V339.089l3,.736Z",
    transform: "translate(-314.811 -339.089)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M350.622,350.521h3V339.089l-3,.736Z",
    transform: "translate(-266.517 -339.089)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M325.185,352.14h-3V340.708l3,.426Z",
    transform: "translate(-304.867 -336.906)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M343.248,352.14h3V340.708l-3,.426Z",
    transform: "translate(-276.462 -336.906)",
    fill: "#661615"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M350.731,571.565c.127-1.444-.578-10.329-.54-11.792,1.74-66.289,3.044-132.421,1.684-198.727-.305-12.962-19.587-14.693-22.14-1.987-1.442,7.177-.906,15.191-1.282,22.46-1.52,29.367-3.452,58.706-6.28,87.976q-4.544,46.992-9.153,93.977c-.021.225-.031.449-.044.672C319.99,568.079,331.541,573.375,350.731,571.565Z",
    transform: "translate(-266.112 -172.039)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M338.657,570.143c-.127-1.444.578-10.327.54-11.792-1.738-66.289-3.041-132.421-1.682-198.727.305-12.962,19.585-14.693,22.138-1.987,1.442,7.177.907,15.191,1.285,22.462,1.52,29.365,3.45,58.7,6.28,87.976q4.541,46.989,9.15,93.975c.023.225.031.448.045.674C367.986,568.769,355.68,572.731,338.657,570.143Z",
    transform: "translate(-233.779 -173.957)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M359.56,274.443c-.373,32.864-.289,65.711-.338,97.427-.136,77.149-1.015,147.506-10.9,194.361-18.857,1.134-31.737,1.879-45.962-7.21-.035-26.443-.994-53.82-1.111-79.385-.035-3.058-.035-6.1-.035-9.141-.1-55.859,1.759-108.764,13.366-155.787A41.486,41.486,0,0,1,334.536,288.5l13.432-7.537Z",
    transform: "translate(-281.977 -274.443)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M398.962,471.562c0,3.044-.014,6.085-.014,9.143-.1,25.614-.519,51.777-.564,78.15-14.216,9.082-37.369,8.951-56.216,7.807,5.179-49.168,2.687-119.84.43-197.381-.921-30.795-1.8-62.658-2.151-94.714l11.635,6.546,13.387,7.508a41.4,41.4,0,0,1,15.167,14.693,41.958,41.958,0,0,1,4.777,11.5,381.575,381.575,0,0,1,7.45,39.536c3.312,23.834,4.9,48.886,5.611,74.751.089,3.7.179,7.408.237,11.132C398.9,450.563,398.962,461.01,398.962,471.562Z",
    transform: "translate(-229.063 -274.277)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M384.37,358.446c0,3.041-.019,6.083-.019,9.141H351.3c-.033-3.058-.033-6.1-.033-9.141Z",
    transform: "translate(-214.468 -161.156)",
    fill: "#ffde14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(15.587 168.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M320.972,360.739v7.555h-4.439l-1.6-2.9a.258.258,0,0,1-.045-.073l-1.01-1.841a3.691,3.691,0,0,1,.55-4.333,3.457,3.457,0,0,1,.921-.728l.059-.042a3.732,3.732,0,0,1,4.57.77,3.4,3.4,0,0,1,.474.653l.268.491Z",
    transform: "translate(-281.109 -330.138)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M320.323,366.209h-8.608l-.134-.223c-.014-.031-.028-.075-.045-.1l-.474-.848a3.727,3.727,0,0,1,1.47-5.059l.073-.045a3.718,3.718,0,0,1,5.061,1.468l1.01,1.841a.256.256,0,0,0,.045.073Z",
    transform: "translate(-284.899 -328.052)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M307.133,352.473l.035-.075a3.924,3.924,0,0,1,5.566-1.51,122.812,122.812,0,0,0,24.4,9.974A4.183,4.183,0,0,1,340,365.846l-.019.078a3.9,3.9,0,0,1-4.97,2.821,130.742,130.742,0,0,1-25.656-10.3A4.727,4.727,0,0,1,307.133,352.473Z",
    transform: "translate(-290.088 -340.393)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M315.464,364.121h-7.642a3.726,3.726,0,0,1,1.87-2.612l.059-.031a3.715,3.715,0,0,1,5.061,1.468l.474.848c.016.028.03.073.045.1Z",
    transform: "translate(-288.648 -325.965)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M333.275,364.439l-.949.536-6.618,3.636-16.579,9.143h-1.973l-.193-.371-3.666-6.665a10.382,10.382,0,0,1-.876-2.107,10.79,10.79,0,0,1,.46-7.628c.148-.327.312-.653.491-.965a10.76,10.76,0,0,1,4.23-4.2l5.712-3.145h.016l.712-.4a10.863,10.863,0,0,1,6.872-1.247h.014c.045,0,.089.014.12.014h.014c.282.044.564.106.846.178a10.728,10.728,0,0,1,4.852,2.6l.016.014a10.812,10.812,0,0,1,2.165,2.762l.089.162,3.591,6.5Z",
    transform: "translate(-296.589 -339.597)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M327.321,363.558l-4.571,2.523-13.475,7.42-.312-.564-3.013-5.461-.668-1.217-2.626-4.779-3-5.446,18.032-9.943,2.745,4.972,3.517,6.382.03.074H324Z",
    transform: "translate(-299.658 -346.09)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M333.564,363.108v5.254a3.691,3.691,0,0,1-.951.756l-.073.031a3.728,3.728,0,0,1-5.017-1.381,3.666,3.666,0,0,1,.207,2.9h-7.213l-.178-.326c.016.028.031.073.045.1a1.5,1.5,0,0,1,.106.223H304.268l-.193-.371,1.423-.787L320,361.52l7.762-4.275,1.973-1.083.653,1.186.594,1.085,1.707,3.086.355.653.268.491Z",
    transform: "translate(-293.701 -332.507)",
    fill: "#f7ae83"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M346.289,302.73c-.209.282-.416.578-.608.86-19.472,27.248-30.306,56.59-25.809,91.525,2.388,18.624,7.093,20.524,14.662,35.083l-5.15,3.011-17.779,10.418-4.124,2.4-1.188.7c-1.825-4.35-3.532-8.756-5-13.3-5.759-17.72-8.906-36.077-8.164-54.924.371-19.62,6.456-40.175,15.524-56.975a196.7,196.7,0,0,1,15.419-24.012c3.831-5.165,8.861-13.342,15.881-12.243C347.372,286.436,350.918,296.3,346.289,302.73Z",
    transform: "translate(-293.021 -259.967)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M337.135,358.444v9.143H301.458c-.031-3.058-.031-6.1-.031-9.143Z",
    transform: "translate(-281.685 -161.159)",
    fill: "#ffde14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(156.902 55.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M361.942,394.822l55.967,3.718a3.685,3.685,0,0,0,3.445-3.084l19.637-90.09c.395-1.8-.512-3.347-2.022-3.448L383,298.2a3.685,3.685,0,0,0-3.445,3.084l-19.637,90.09C359.525,393.181,360.432,394.723,361.942,394.822Z",
    transform: "translate(-359.828 -298.198)",
    fill: "#5b7234"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M386.705,322.621l.019-.085c.51-2.339,2.511-4.129,4.467-4l7.769.5c1.956.132,3.131,2.13,2.621,4.469l-.019.084c-.51,2.339-2.511,4.129-4.467,4l-7.767-.5C387.37,326.959,386.2,324.958,386.705,322.621Z",
    transform: "translate(-323.741 -270.775)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M385.905,326.271l.019-.085c.51-2.339,2.511-4.129,4.467-4l9.34.613c1.959.129,3.131,2.13,2.621,4.469l-.019.085c-.51,2.339-2.508,4.129-4.465,4l-9.34-.613C386.57,330.609,385.4,328.61,385.905,326.271Z",
    transform: "translate(-324.82 -265.853)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M385.105,329.921l.019-.085c.51-2.337,2.511-4.129,4.467-4l9,.589c1.959.131,3.131,2.13,2.621,4.469l-.019.085c-.51,2.339-2.508,4.129-4.465,4l-9-.589C385.77,334.261,384.6,332.26,385.105,329.921Z",
    transform: "translate(-325.899 -260.93)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M384.7,333.125l.016-.077c.453-2.074,2.227-3.664,3.964-3.546l6.9.449c1.738.115,2.778,1.891,2.327,3.967l-.016.075c-.453,2.076-2.229,3.664-3.964,3.549l-6.9-.451C385.288,336.975,384.246,335.2,384.7,333.125Z",
    transform: "translate(-326.429 -255.99)",
    fill: "#f7ae83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(34.412 56.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M329.362,366.346a6.9,6.9,0,0,1-5.728-2.635c-2.189-2.52-3.3-6.01-4.279-9.089l-8.868-27.843c-1.491-4.676-3.347-10.494-2.668-16.14a13.119,13.119,0,0,1,4.134-8.279A5.8,5.8,0,0,1,317.393,301l-.275,1.9a4.6,4.6,0,0,0-4.253,1.1,11.122,11.122,0,0,0-3.5,7.022c-.615,5.122,1.078,10.43,2.569,15.113l8.868,27.843c.916,2.875,1.952,6.13,3.859,8.328,1.646,1.893,4.016,2.621,5.637,1.743l.23-.127.254.073c1.776.512,3.927-.716,5.122-2.924,1.386-2.558,1.691-5.961,1.961-8.965l2.619-29.1c.439-4.9.94-10.444-.773-15.311a11.125,11.125,0,0,0-4.942-6.1,4.6,4.6,0,0,0-4.392-.15l-.679-1.8a5.786,5.786,0,0,1,5.606.15,13.115,13.115,0,0,1,5.832,7.184c1.886,5.364,1.339,11.447.9,16.335l-2.619,29.106c-.286,3.215-.613,6.863-2.2,9.8-1.494,2.76-4.115,4.27-6.461,3.741A4.3,4.3,0,0,1,329.362,366.346Z",
    transform: "translate(-307.674 -298.243)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M315.878,303.283l-3.751.117a1,1,0,0,1-.911-.977l-.167-1.522a1,1,0,0,1,.679-1.153l3.687-.7c.484-.092.949.35,1.017.965l.23,2.107A.963.963,0,0,1,315.878,303.283Z",
    transform: "translate(-303.133 -298.182)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M316.73,303.025l3.687-.7a1,1,0,0,0,.679-1.151l-.167-1.522a1,1,0,0,0-.911-.977l-3.751.117a.963.963,0,0,0-.784,1.163l.23,2.107C315.781,302.675,316.246,303.117,316.73,303.025Z",
    transform: "translate(-297.153 -298.673)",
    fill: "#bed3e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M330.058,344.192c-2.574-2.264-2.424-5.472-2.281-8.572.035-.737.07-1.477.066-2.208-.012-1.94-.085-3.835-.157-5.733-.063-1.66-.127-3.321-.15-5.019-.054-3.781-.951-8.516-3.309-10.472a6.273,6.273,0,0,0-5.209-.74,5.172,5.172,0,0,0-3.676,2.48,11.713,11.713,0,0,0-.672,6l1.644,15.823-2.215.23-1.644-15.823a13.856,13.856,0,0,1,.848-7.123,7.256,7.256,0,0,1,5.2-3.751,8.386,8.386,0,0,1,7.14,1.193c3.7,3.07,4.084,10.08,4.112,12.156.023,1.677.089,3.321.15,4.963.075,1.923.148,3.842.16,5.808,0,.768-.031,1.548-.068,2.32-.132,2.814-.244,5.242,1.526,6.8Z",
    transform: "translate(-266.965 -227.852)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M321.822,333.717a62.92,62.92,0,0,1-.479-6.682c-.07-1.954-.143-3.976-.39-5.977-.047-.373-.084-.777-.124-1.191a14.133,14.133,0,0,0-.517-3.135c-.289-.8-1.177-1.557-1.881-1.336-2.511.728-1.635,7.659-.9,11.729l-2.191.395c-2.055-11.412.171-13.594,2.339-14.221a3.959,3.959,0,0,1,4.73,2.685,15.754,15.754,0,0,1,.639,3.678c.038.39.073.77.115,1.123.261,2.1.336,4.169.406,6.172a61.3,61.3,0,0,0,.458,6.452Z",
    transform: "translate(-264.024 -222.258)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(39.866 100.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M310,317.417v28.547a9.416,9.416,0,0,0,9.416,9.416h10.707a9.416,9.416,0,0,0,9.416-9.416V317.417Z",
    transform: "translate(-309.995 -317.417)",
    fill: "#5b7234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 29.539,
    height: 7.171,
    transform: "translate(0 0)",
    fill: "#ffde14"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M316.374,344.576l-2.208-.287a30.152,30.152,0,0,0-1.25-13.232c-.162-.491-.336-.982-.51-1.47a22.089,22.089,0,0,1-1.294-4.7c-.289-2.295-.078-5.665,1.461-7.621a4.376,4.376,0,0,1,4.979-1.172,3.939,3.939,0,0,1,2.957,3.476h-2.227c0-.5-.627-1.085-1.458-1.372a2.253,2.253,0,0,0-2.5.446c-1.036,1.315-1.245,4.016-1,5.966a20.517,20.517,0,0,0,1.181,4.232c.181.5.362,1.012.531,1.522A32.43,32.43,0,0,1,316.374,344.576Z",
    transform: "translate(-268.771 -218.686)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(37.96 124.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 4.459,
    height: 6.127,
    transform: "translate(6.675)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(0 4.323)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 8.904,
    cy: 8.904,
    r: 8.904,
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M319.6,335.36a4.205,4.205,0,1,1-4.206-4.206A4.2,4.2,0,0,1,319.6,335.36Z",
    transform: "translate(-306.485 -326.455)",
    fill: "#bed3e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(41.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M343.573,314.276h0a17.44,17.44,0,0,1-17.391-17.389v-19a17.441,17.441,0,0,1,17.391-17.389h0a17.441,17.441,0,0,1,17.389,17.389v19A17.439,17.439,0,0,1,343.573,314.276Z",
    transform: "translate(-289.815 -161.048)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M343.573,260.495c9.564,0,16.483,9.834,15.5,20.548l-1.646,17.882c-.7,7.635-6.907,13.331-13.85,13.331h0c-6.945,0-13.15-5.7-13.852-13.331l-1.646-17.882c-.987-10.714,5.932-20.548,15.5-20.548a17.441,17.441,0,0,0-17.391,17.389v19a17.44,17.44,0,0,0,17.391,17.389h0a17.439,17.439,0,0,0,17.389-17.389v-19A17.441,17.441,0,0,0,343.573,260.495Z",
    transform: "translate(-289.815 -161.048)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M353.82,290.376a36.307,36.307,0,0,0,7.025-.707,17.252,17.252,0,0,0,.117-1.949v-19c0-.47-.035-.935-.07-1.4a26.534,26.534,0,0,1-8.612,1.461H335a26.483,26.483,0,0,1-8.744-1.491c-.04.472-.073.944-.073,1.426v19a17.459,17.459,0,0,0,.115,1.933,36.268,36.268,0,0,0,7.17.723Z",
    transform: "translate(-289.815 -151.881)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(0 68.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M329.459,252.052s-8.664-8.479-15.585-2.945c-8.176,6.534.376,30.055,14.878,27.565Z",
    transform: "translate(-310.698 -247.232)",
    fill: "#f7ae83"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(84.978 68.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M346.88,252.052s8.664-8.479,15.585-2.945c8.176,6.534-.376,30.055-14.878,27.565Z",
    transform: "translate(-346.88 -247.232)",
    fill: "#f7ae83"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M357.182,334.457c-29.94,0-39.182-35.56-41.937-61.594a41.083,41.083,0,0,1,40.234-45.436c.319,0,.643,0,.968,0q.606,0,1.2.007A41.117,41.117,0,0,1,398,272.083C395.711,298.458,387.108,334.457,357.182,334.457Z",
    transform: "translate(-304.877 -205.65)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M398.717,221.412c15.188,10.388,1.449,30.647,1.449,30.647s15.12,14.806-.444,49.656l-2.774-.566c1.769-11.161.707-24.745,0-26.882-2.1-6.372-13.286-9.768-12.713-16.654,0,0-34.268,10.714-52.815.19,0,0-1.466,8.828-6.546,14.4-4.253,4.657-1.832,20.881-1.285,27.9l-2.847.279c-1.689-7.149-5.808-20.024-6.25-23.817-.279-2.391-1.3-11.874-1.733-18.655a33.388,33.388,0,0,1,3.37-17.234,22.574,22.574,0,0,1,6.4-8.006C332.494,225.252,384.943,211.99,398.717,221.412Z",
    transform: "translate(-308.016 -218.152)",
    fill: "#d94350"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(35.16 93.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M362.5,258.112a19.531,19.531,0,0,1-1.4,3.225,21.72,21.72,0,0,1-6.886,7.865c-.411.275-.836.536-1.28.78a18.248,18.248,0,0,1-9.03,2.257,19.3,19.3,0,0,1-8.31-1.759c-.4-.183-.782-.385-1.151-.592a19.4,19.4,0,0,1-7.1-7.112,18.11,18.11,0,0,1-1.677-3.614c.031.016.54.317,1.461.754a38.758,38.758,0,0,0,16.443,3.521c.113,0,.225,0,.334,0l.371-.009a38.655,38.655,0,0,0,16.471-4.312C361.829,258.549,362.449,258.147,362.5,258.112Z",
    transform: "translate(-325.668 -258.112)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M347.235,264.011a18.248,18.248,0,0,1-9.03,2.257,19.3,19.3,0,0,1-8.309-1.759,18.168,18.168,0,0,1,8.889-1.97A23.7,23.7,0,0,1,347.235,264.011Z",
    transform: "translate(-319.968 -252.142)",
    fill: "#d94350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M362.5,258.112a19.531,19.531,0,0,1-1.4,3.225,30.875,30.875,0,0,1-16.616,4.528,44.863,44.863,0,0,1-17.14-3.088,18.11,18.11,0,0,1-1.677-3.614c.031.016.54.317,1.461.754a38.758,38.758,0,0,0,16.443,3.521c.113,0,.225,0,.334,0l.371-.009a38.655,38.655,0,0,0,16.471-4.312C361.829,258.549,362.449,258.147,362.5,258.112Z",
    transform: "translate(-325.668 -258.112)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(23.518 53.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M320.711,249.965s2.3-6.127,7.64-8.11a14.052,14.052,0,0,1,10.595-.047,1.822,1.822,0,0,1,1.029,2.156h0a1.831,1.831,0,0,1-2.386,1.252C334.385,244.077,327.459,242.872,320.711,249.965Z",
    transform: "translate(-320.711 -240.808)",
    fill: "#d94350"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(62.844 53.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M357.058,249.449s-2.574-6.019-8-7.757a14.049,14.049,0,0,0-10.585.427,1.824,1.824,0,0,0-.932,2.2h0a1.834,1.834,0,0,0,2.44,1.144C343.133,244.179,350,242.667,357.058,249.449Z",
    transform: "translate(-337.456 -240.88)",
    fill: "#d94350"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(44.463 110.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M338.861,269.345a16.029,16.029,0,0,1-8.695-2.3,1.1,1.1,0,0,1,1.127-1.893c7.342,4.373,14.482.209,14.78.028a1.1,1.1,0,0,1,1.137,1.888A18.358,18.358,0,0,1,338.861,269.345Z",
    transform: "translate(-329.629 -265)",
    fill: "#e29260"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M338.114,254.472s7.969,10.907,18.366-.427c.345-.38-.5-2.027-.646-2.4-1.393-3.405-5.071-5.209-8.363-5.247a11.2,11.2,0,0,0-8.453,3.948A5.5,5.5,0,0,0,338.114,254.472Z",
    transform: "translate(-273.78 -180.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M351.529,252.622a6.153,6.153,0,1,1-6.153-6.153A6.153,6.153,0,0,1,351.529,252.622Z",
    transform: "translate(-272.23 -179.963)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M338.09,255.753c.045-2.318.218-4.81,1.705-6.964a6.8,6.8,0,0,1,3.041-2.389,10.338,10.338,0,0,1,3.741-.648,10.17,10.17,0,0,1,6.863,2.734,10.808,10.808,0,0,1,3.312,6.315,14.43,14.43,0,0,0-4.228-5.219,10.131,10.131,0,0,0-5.972-2.015,7.09,7.09,0,0,0-5.651,2.09C339.506,251.242,338.8,253.529,338.09,255.753Z",
    transform: "translate(-273.756 -180.929)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M339.371,254.472s-7.969,10.907-18.366-.427c-.345-.38.5-2.027.646-2.4,1.39-3.405,5.071-5.209,8.363-5.247a11.2,11.2,0,0,1,8.453,3.948A5.5,5.5,0,0,1,339.371,254.472Z",
    transform: "translate(-296.908 -180.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M322.406,252.622a6.153,6.153,0,1,0,6.153-6.153A6.153,6.153,0,0,0,322.406,252.622Z",
    transform: "translate(-294.908 -179.963)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M339.494,255.753c-.712-2.224-1.416-4.512-2.811-6.095a7.092,7.092,0,0,0-5.653-2.09,10.13,10.13,0,0,0-5.97,2.015,14.406,14.406,0,0,0-4.227,5.219,10.806,10.806,0,0,1,3.311-6.315,10.17,10.17,0,0,1,6.863-2.734,10.345,10.345,0,0,1,3.741.648,6.8,6.8,0,0,1,3.041,2.389C339.273,250.943,339.449,253.435,339.494,255.753Z",
    transform: "translate(-297.03 -180.929)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M343.6,254.191a4.226,4.226,0,0,1-4.134,3.422h-3.8a4.226,4.226,0,0,1-4.133-3.422h-.909a5.233,5.233,0,0,0,5.2,4.878h3.474a5.233,5.233,0,0,0,5.2-4.878Z",
    transform: "translate(-283.815 -169.549)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(43.437 17.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M329.4,235.958a36.093,36.093,0,0,0,19.176,1.031c6.16-1.43,12.185-4.965,15.113-10.761.153-.305-.3-.646-.512-.35a25.511,25.511,0,0,1-15.05,10.2,36.355,36.355,0,0,1-18.61-.665c-.345-.1-.453.435-.117.543Z",
    transform: "translate(-329.192 -225.764)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(0 35.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M258.6,234.255c4.979-1.508,8.955-1.409,16.811,5.221,11.217,9.463,14.829,22.9,16.3,38.435.622,6.571.073,14.148-.3,20.743-.5,8.774-1.127,17.647,4.084,25.219a86.1,86.1,0,0,1,6.064,11.36,19.723,19.723,0,0,1,.77,14.845,17.551,17.551,0,0,1-9.754,10.414,22.28,22.28,0,0,0-.928-6.975c-.792-2.2-2.461-4.173-4.6-4.549a9.324,9.324,0,0,1-3.1,9.329,14.746,14.746,0,0,0-4.411-9.016c-.251,2.356-3.405,7.144-4.126,7.826-2.983,2.818-6.529,3.1-10.341,4.249a17.871,17.871,0,0,0,2.6-9.7,17.31,17.31,0,0,1-10.362,8.979,27.271,27.271,0,0,0,1.757-7.859,22.793,22.793,0,0,1-15.9,8.164",
    transform: "translate(-60.91 -225.885)",
    fill: "#ffde14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M307.943,246.62c-9.181-17.377-23.315-17.636-36.753-15.407a57.419,57.419,0,0,0-27.321,12.678c-11.217,9.465-17.154,24.393-19.352,39.323a98.022,98.022,0,0,0-.881,19.792c.5,8.774,2.227,18.845-2.985,26.417-2.356,3.424-5.343,6.372-7.163,10.162a19.723,19.723,0,0,0-.77,14.846,17.544,17.544,0,0,0,9.754,10.414,22.281,22.281,0,0,1,.925-6.975c.794-2.2,2.464-4.173,4.606-4.549a9.327,9.327,0,0,0,3.1,9.329,14.752,14.752,0,0,1,4.415-9.019c-1.083,1.022,2.5,6.529,3.065,7.187,2.428,2.823,5.843,3.034,9.275,3.986-.465-2.616-.74-5.834,1.207-7.455a16.949,16.949,0,0,0,10.181,7.858,6.446,6.446,0,0,1,1.454-7.68,20.509,20.509,0,0,0,5.1,5.357,8.512,8.512,0,0,0,6.818,1.426",
    transform: "translate(-103.432 -230.236)",
    fill: "#ffde14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M227.759,373.62a4.142,4.142,0,0,0-1.015.686c-.164-.308-.326-.62-.477-.946l-19.526-42.3c-1.994-4.317-1.792-8.695.446-9.728s5.7,1.653,7.694,5.97l19.526,42.3c.122.263.235.528.341.792Z",
    transform: "translate(-111.868 -107.687)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M230.887,341.436l-18.5,8.541,67.924,143.736,19.652,18.262-1.149-26.8Z",
    transform: "translate(-102.407 -80.271)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M218.653,342.964l-2.96,1.366,67.924,143.736L295.5,509.915l-8.92-23.216Z",
    transform: "translate(-97.944 -78.211)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 29.345,
    height: 6.46,
    rx: 0.902,
    transform: "translate(103.753 266.92) rotate(-24.777)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M207.939,319.746h0a8.012,8.012,0,0,0-3.906,10.6h0a8.012,8.012,0,0,0,10.6,3.906h0a8.012,8.012,0,0,0,3.906-10.6h0A8.011,8.011,0,0,0,207.939,319.746Z",
    transform: "translate(-114.653 -110.511)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M262.543,413.1c0,41.8-9.364,56.78-20.917,56.78S220.71,454.9,220.71,413.1s9.366-75.686,20.917-75.686S262.543,371.3,262.543,413.1Z",
    transform: "translate(-91.178 -85.699)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M255.032,433.62c-2.064,47.27-10.639,72.088-13.826,72.088-3.713,0-18.08-36.035-18.08-77.835,0-26.4,3.692-39.743,15.242-39.743S256.854,391.86,255.032,433.62Z",
    transform: "translate(-87.92 -17.3)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M254.44,399.6l-32.013,4.17V386.779l32.013,4.17Z",
    transform: "translate(-88.862 -19.122)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 15.515,
    cy: 21.138,
    rx: 15.515,
    ry: 21.138,
    transform: "translate(121.681 355.017)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M226.1,381.4a11.6,11.6,0,0,0-3.7.632C229.172,384.3,234.2,392.6,234.2,402.534s-5.033,18.239-11.809,20.506a11.659,11.659,0,0,0,3.7.632c8.57,0,15.517-9.465,15.517-21.137S234.67,381.4,226.1,381.4Z",
    transform: "translate(-88.904 -26.38)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M223.37,423.183l31.225-10.021.639,72.26L247.5,489.2s6.8-20.1-19.954-25.776Z",
    transform: "translate(-87.59 16.458)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M267.082,460.34s9.355-23.4-19.954-25.776c-23.653,20.36-38.28,31.044-38.28,31.044S211.319,481.111,267.082,460.34Z",
    transform: "translate(-107.175 45.321)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M210.647,452.376c-1.177.888-1.8,1.341-1.8,1.341s2.471,15.5,58.234-5.268a23.407,23.407,0,0,0,1.217-5.068C232.106,456.535,216.767,454.859,210.647,452.376Z",
    transform: "translate(-107.175 57.212)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M254.594,413.162,223.37,423.184l1.312,12.655,30.039-8.421Z",
    transform: "translate(-87.591 16.458)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M242.894,413.1c0,41.8,9.366,56.78,20.917,56.78s20.917-14.977,20.917-56.78-9.364-75.686-20.917-75.686S242.894,371.3,242.894,413.1Z",
    transform: "translate(-61.26 -85.699)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M244.872,433.62c2.062,47.27,10.637,72.088,13.826,72.088,3.713,0,18.079-36.035,18.079-77.835,0-26.4-3.692-39.743-15.245-39.743S243.05,391.86,244.872,433.62Z",
    transform: "translate(-58.983 -17.3)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M245.359,399.6l32.013,4.17V386.779l-32.013,4.17Z",
    transform: "translate(-57.936 -19.122)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 15.515,
    cy: 21.138,
    rx: 15.515,
    ry: 21.138,
    transform: "translate(200.289 355.017)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M266.352,381.4a11.609,11.609,0,0,1,3.706.632c-6.776,2.266-11.811,10.573-11.811,20.506s5.035,18.239,11.811,20.506a11.673,11.673,0,0,1-3.706.632c-8.568,0-15.515-9.465-15.515-21.137S257.784,381.4,266.352,381.4Z",
    transform: "translate(-50.548 -26.38)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M276.343,423.183l-31.225-10.021-.639,72.26,7.736,3.781s-6.8-20.1,19.954-25.776Z",
    transform: "translate(-59.122 16.458)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M248.589,460.34s-9.354-23.4,19.954-25.776c23.65,20.36,38.28,31.044,38.28,31.044S304.35,481.111,248.589,460.34Z",
    transform: "translate(-55.495 45.321)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M304.908,452.376c1.177.888,1.8,1.341,1.8,1.341s-2.473,15.5-58.234-5.268a23.48,23.48,0,0,1-1.219-5.068C283.447,456.535,298.786,454.859,304.908,452.376Z",
    transform: "translate(-55.379 57.212)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M244.824,413.162l31.225,10.022-1.313,12.655L244.7,427.418Z",
    transform: "translate(-58.827 16.458)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M280.283,348.811H246.762c-11.506,0-21.779-3.974-22.965-9.094a29.452,29.452,0,0,0,.7,6.935l28.432,79.5s3.241,3.225,6.242,3.225h8.706c3,0,6.243-3.225,6.243-3.225l28.43-79.5a29.331,29.331,0,0,0,.7-6.935C302.062,344.837,291.789,348.811,280.283,348.811Z",
    transform: "translate(-87.022 -82.59)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M283.6,395.565H250.081c-11.558,0-21.875-4.007-22.986-9.159l-5.547-61.374c-1.881-10.618,8.683-19.984,23.625-19.984h43.339c14.939,0,25.5,9.366,23.622,19.984l-5.545,61.374C305.477,391.559,295.157,395.565,283.6,395.565Z",
    transform: "translate(-90.341 -129.344)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M280.283,348.811H246.762c-11.506,0-21.779-3.974-22.965-9.094a29.452,29.452,0,0,0,.7,6.935l.519,1.578c3.243,3.955,12.048,6.78,21.748,6.78h33.522c9.7,0,18.5-2.825,21.746-6.78l.519-1.578a29.331,29.331,0,0,0,.7-6.935C302.062,344.837,291.789,348.811,280.283,348.811Z",
    transform: "translate(-87.022 -82.59)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M327,323.953c0,32.5-24.543,58.837-54.819,58.837s-54.819-26.342-54.819-58.837,24.543-40.847,54.819-40.847S327,291.46,327,323.953Z",
    transform: "translate(-95.686 -158.935)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M198.844,308.969c-9.284-.644-17.194,4.357-17.669,11.172s6.67,12.863,15.954,13.507,17.194-4.357,17.669-11.172S208.128,309.615,198.844,308.969Z",
    transform: "translate(-144.524 -124.132)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M184.2,329.014c4.559,8.833,11.872,23.679,15.181,28.378,5.606,7.966,24.759-2.433,26.473-3.373,2.682-1.468.106-6.809-8.849-21.187-14.918-23.953-30.375-55.441-38.714-50.873S171.913,305.2,184.2,329.014Z",
    transform: "translate(-155.208 -161.082)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M173.535,297.407l4.6,26.658,19.208-1.789,10.1-11.065L192.2,284.271Z",
    transform: "translate(-154.798 -157.364)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M275.956,335.065c0,9.307,5.538,16.851,12.37,16.851s12.37-7.544,12.37-16.851-5.538-16.851-12.37-16.851S275.956,325.758,275.956,335.065Z",
    transform: "translate(-16.673 -111.589)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M297.9,366.481c1.358-9.848,3.922-26.2,3.922-31.946,0-9.74-21.647-12.26-23.589-12.48-3.039-.34-4.009,5.508-4.96,22.42-1.588,28.174-7.074,62.818,2.374,63.884S294.238,393.032,297.9,366.481Z",
    transform: "translate(-24.379 -106.427)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M291.858,372.732l11.586-24.444-16.737-9.593-14.628,3.235-3.043,30.8Z",
    transform: "translate(-26.005 -83.968)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M283.776,343.053l-13.618,3.012.409-4.136,14.628-3.235,16.737,9.593L300,352.354Z",
    transform: "translate(-24.492 -83.97)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M270.475,341c2.621,7.168,11.14,37.362,15.106,39.875,3.542,2.245,20.261,3.737,22.655,0,3.074-4.8,2.778-25.149-4.979-54.25-8.932-33.51-18.516-44.309-27.84-42.094S258.575,308.421,270.475,341Z",
    transform: "translate(-32.327 -157.394)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M271.7,332.729l29.516,3.324V322.5L271.7,325.829Z",
    transform: "translate(-22.413 -105.802)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M264.961,366.491h0a3.4,3.4,0,0,1,.1-4.794l9.455-9.089a3.4,3.4,0,0,1,4.791.094h0a3.4,3.4,0,0,1-.094,4.793l-9.456,9.089A3.4,3.4,0,0,1,264.961,366.491Z",
    transform: "translate(-32.771 -66.474)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M273.12,369.541h0a3.4,3.4,0,0,1-4.608-1.322l-4.188-7.56a3.4,3.4,0,0,1,1.322-4.608h0a3.4,3.4,0,0,1,4.608,1.322l4.188,7.56A3.4,3.4,0,0,1,273.12,369.541Z",
    transform: "translate(-32.929 -61.132)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M277.044,378.477h0a3.4,3.4,0,0,0,4.1-2.48l2.882-11.687a3.4,3.4,0,0,0-2.48-4.1h0a3.4,3.4,0,0,0-4.1,2.48l-2.882,11.687A3.4,3.4,0,0,0,277.044,378.477Z",
    transform: "translate(-18.684 -55.089)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M273.743,376.619h0a3.4,3.4,0,0,0,4.1-2.48l2.1-8.521a3.4,3.4,0,0,0-2.48-4.1h0a3.4,3.4,0,0,0-4.1,2.478l-2.1,8.523A3.4,3.4,0,0,0,273.743,376.619Z",
    transform: "translate(-23.135 -53.325)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M267.423,377.328h0a3.4,3.4,0,0,1-2.478-4.1l3.14-12.734a3.4,3.4,0,0,1,4.1-2.478h0a3.4,3.4,0,0,1,2.478,4.1l-3.14,12.732A3.4,3.4,0,0,1,267.423,377.328Z",
    transform: "translate(-31.656 -58.049)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M270.365,376.408h0a3.4,3.4,0,0,1-2.48-4.1l2.1-8.521a3.4,3.4,0,0,1,4.1-2.48h0a3.4,3.4,0,0,1,2.48,4.1l-2.1,8.523A3.4,3.4,0,0,1,270.365,376.408Z",
    transform: "translate(-27.691 -53.609)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 29.698,
    height: 28.632,
    rx: 3.079,
    transform: "matrix(-0.971, -0.239, 0.239, -0.971, 263.43, 316.983)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M193.79,304.5l9.4-10.3,2.047,3.617-10.1,11.065-19.209,1.789-.765-4.436Z",
    transform: "translate(-152.598 -143.972)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M217.883,305.21c-5.561,5.228-29.97,24.933-30.722,29.569-.672,4.138,4.53,20.1,8.906,20.83,5.627.939,24.216-7.335,47.923-25.91,27.3-21.389,33.46-34.447,27.756-42.148S243.154,281.459,217.883,305.21Z",
    transform: "translate(-136.502 -158.502)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M271.494,279.929s-57.017-16.222-70.5,29.118l54.495,18.836Z",
    transform: "translate(-117.767 -167.026)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M265.167,277.723,251.09,319.9l-48.32-16.7a53.1,53.1,0,0,0-1.776,5.014l54.495,18.836L271.494,279.1S269.094,278.416,265.167,277.723Z",
    transform: "translate(-117.767 -166.195)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 9.276,
    cy: 9.276,
    r: 9.276,
    transform: "translate(128.447 151.581)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M233.557,302.139a5.945,5.945,0,1,1-5.947-5.944A5.948,5.948,0,0,1,233.557,302.139Z",
    transform: "translate(-89.888 -141.283)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M250.4,279.929s57.017-16.222,70.5,29.118l-54.495,18.836Z",
    transform: "translate(-51.131 -167.026)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M256.732,277.723,270.807,319.9l48.32-16.7a51.76,51.76,0,0,1,1.776,5.014l-54.495,18.836-16-47.954S252.805,278.416,256.732,277.723Z",
    transform: "translate(-51.131 -166.195)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M253.27,304.052a9.276,9.276,0,1,0,9.275-9.275A9.275,9.275,0,0,0,253.27,304.052Z",
    transform: "translate(-47.267 -143.196)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M254.688,302.139a5.944,5.944,0,1,0,5.944-5.944A5.946,5.946,0,0,0,254.688,302.139Z",
    transform: "translate(-45.355 -141.283)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M198.406,300.3l-14.626,34.735,12.781,4.7,5.5-39.434Z",
    transform: "translate(-140.983 -135.743)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M189.334,278.256h0a3.4,3.4,0,0,1,1.872,4.413l-4.913,12.159a3.4,3.4,0,0,1-4.413,1.872h0a3.4,3.4,0,0,1-1.874-4.413l4.913-12.159A3.4,3.4,0,0,1,189.334,278.256Z",
    transform: "translate(-146.402 -165.808)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M187.77,274.076h0a3.4,3.4,0,0,1,2.68,3.974l-1.649,8.483a3.4,3.4,0,0,1-3.976,2.68h0a3.4,3.4,0,0,1-2.68-3.976l1.651-8.481A3.4,3.4,0,0,1,187.77,274.076Z",
    transform: "translate(-143.271 -171.198)",
    fill: "#bed3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M167.715,273.068h0a3.4,3.4,0,0,0-1.928,4.389l7.149,18.345a3.4,3.4,0,0,0,4.389,1.928h0a3.4,3.4,0,0,0,1.928-4.39L172.1,275A3.4,3.4,0,0,0,167.715,273.068Z",
    transform: "translate(-165.557 -172.783)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M170.018,270.127h0a3.4,3.4,0,0,0-1.926,4.39l6.947,17.831a3.4,3.4,0,0,0,4.389,1.928h0a3.4,3.4,0,0,0,1.928-4.39l-6.949-17.831A3.4,3.4,0,0,0,170.018,270.127Z",
    transform: "translate(-162.45 -176.749)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M176.242,268.457h0c1.736-.679,3.953.82,4.927,3.328l6.853,17.645c.975,2.508.35,5.115-1.386,5.794h0c-1.736.676-3.955-.822-4.927-3.33l-6.853-17.643C173.882,271.74,174.5,269.133,176.242,268.457Z",
    transform: "translate(-153.637 -178.911)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M172.779,268.036h0a3.4,3.4,0,0,1,4.387,1.928l7.241,18.58a3.4,3.4,0,0,1-1.928,4.39h0a3.4,3.4,0,0,1-4.39-1.928l-7.238-18.58A3.4,3.4,0,0,1,172.779,268.036Z",
    transform: "translate(-158.73 -179.569)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 29.698,
    height: 28.632,
    rx: 3.079,
    transform: "translate(4.476 115.571) rotate(-21.288)",
    fill: "#a7bbc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M246.232,428.2c-2.936-1.574-3.154-6.616-.484-9.716a129.109,129.109,0,0,0,30-101.81c-.561-4.054,2.358-8.171,5.677-7.9a178.443,178.443,0,0,1,34.259,6.259c54.433,17.034,94.092,56.878,107.141,101.739a6.986,6.986,0,0,1-1.794,2.325c-34.48,28.3-87.779,38.637-140.909,22.979A178.5,178.5,0,0,1,246.232,428.2Z",
    transform: "translate(-59.932 -124.343)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M253.13,412.51c-2.428-1.294-2.626-5.409-.432-7.931a103.864,103.864,0,0,0,24.458-82.985c-.477-3.309,1.921-6.661,4.662-6.43a149.529,149.529,0,0,1,28.315,5.216c45.006,14.075,77.884,46.714,88.805,83.364a5.65,5.65,0,0,1-1.477,1.891c-28.383,22.983-72.37,31.253-116.3,18.307A149.643,149.643,0,0,1,253.13,412.51Z",
    transform: "translate(-50.096 -115.719)",
    fill: "#ffde14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M262.83,326.368q5.27-5.249,10.533-10.5c-2.149-.279-4.3-.521-6.43-.7-2.741-.23-5.139,3.121-4.662,6.43C262.5,323.176,262.675,324.771,262.83,326.368Z",
    transform: "translate(-35.211 -115.719)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M314.98,318.087q-20,19.929-39.99,39.875c-.324,1.278-.639,2.558-1.015,3.833A103.531,103.531,0,0,1,252.7,400.619c-1.947,2.238-2,5.721-.294,7.382l81.684-81.684A152.264,152.264,0,0,0,314.98,318.087Z",
    transform: "translate(-50.093 -111.76)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M340.506,339.556q-28.7,28.764-57.428,57.5a137.023,137.023,0,0,0,15.25-1.193l47.688-47.691C344.315,345.249,342.488,342.37,340.506,339.556Z",
    transform: "translate(-7.068 -82.807)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M340.585,326.947Q301,366.53,261.414,406.116c1.961.667,3.929,1.322,5.94,1.917,4.876,1.435,9.747,2.569,14.6,3.492q36.318-36.325,72.6-72.687A137.052,137.052,0,0,0,340.585,326.947Z",
    transform: "translate(-36.284 -99.811)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 38.06,
    height: 6.46,
    rx: 0.902,
    transform: "translate(111.346 279.797) rotate(-24.777)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M251.226,320.58h0A17.326,17.326,0,0,1,233.95,303.3V284.428a17.326,17.326,0,0,1,17.276-17.276h0A17.327,17.327,0,0,1,268.5,284.428V303.3A17.327,17.327,0,0,1,251.226,320.58Z",
    transform: "translate(-73.322 -180.451)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M251.226,267.152c9.5,0,16.377,9.77,15.395,20.412l-1.635,17.765c-.7,7.588-6.863,13.244-13.76,13.244h0c-6.9,0-13.063-5.655-13.76-13.244l-1.637-17.765c-.979-10.641,5.895-20.412,15.4-20.412a17.326,17.326,0,0,0-17.276,17.276V303.3a17.326,17.326,0,0,0,17.276,17.276h0A17.327,17.327,0,0,0,268.5,303.3V284.428A17.327,17.327,0,0,0,251.226,267.152Z",
    transform: "translate(-73.322 -180.451)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M261.407,296.838a36.209,36.209,0,0,0,6.978-.7,17.58,17.58,0,0,0,.117-1.938V275.323c0-.467-.035-.928-.073-1.388a26.3,26.3,0,0,1-8.554,1.452H242.708a26.323,26.323,0,0,1-8.685-1.482c-.04.47-.073.939-.073,1.419V294.2a17.291,17.291,0,0,0,.115,1.921,35.962,35.962,0,0,0,7.121.719Z",
    transform: "translate(-73.322 -171.345)",
    fill: "#e29260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M253.989,261.653s5.416-4.836,10.829-1.16,3.483,22.241-10.829,21.274",
    transform: "translate(-46.298 -191.291)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M235.162,261.655s-5.416-4.836-10.829-1.16-3.483,22.241,10.829,21.274",
    transform: "translate(-90.042 -191.288)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M299.965,257.256c-6-25.527-36.939-21.466-36.939-21.466s-30.943-4.061-36.939,21.466c0,0-3.969,32.23.672,48.088s25.022,33.526,36.267,33.526,31.626-17.669,36.267-33.526S299.965,257.256,299.965,257.256Z",
    transform: "translate(-86.057 -223.065)",
    fill: "#f7ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M262.212,269.527c-.458-.5-6.109-.787-13.392-.787s-12.934.284-13.389.787c-.512.324,2.7,11.823,13.389,11.823S262.721,269.851,262.212,269.527Z",
    transform: "translate(-71.395 -178.309)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(165.811 87.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M259.387,274.651c-2.912,4.559-7.241,8.9-11.987,8.711-5.15-.19-8.946-4.319-11.243-8.258C240.175,271.584,250.812,267.591,259.387,274.651Z",
    transform: "translate(-236.157 -263.322)",
    fill: "#d94350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M256.988,268.13c-.078,3.206-.8,3.206-.8,3.206-2.995,1.5-14.439,2.863-18.756,0-.456-.3-.538-1.818-.622-2.846a1.123,1.123,0,0,1,.674-.294C244.627,267.768,253.749,267.1,256.988,268.13Z",
    transform: "translate(-235.282 -267.585)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M295.238,240.751c3.488,3.615.08,10.994-1.3,14.937a65.846,65.846,0,0,1-4.084,9.918,32.971,32.971,0,0,1-7.537,9.275,12.04,12.04,0,0,1-6.172,3.164,1.026,1.026,0,0,1-.827-.16.988.988,0,0,1-.235-.712,10.01,10.01,0,0,1,1.745-5.038,29.467,29.467,0,0,1-10.881,6.214,71.929,71.929,0,0,0,8.643-10.747,51.809,51.809,0,0,1-33.259,12.913,5.243,5.243,0,0,1,1.559-3.126q2.677-3.227,5.353-6.456-4.731,2.766-9.3,5.792c-2.87,1.9-11.262,9.124-12.5,16.94-3.166-3.286-4.218-8.389-4.537-12.783a47.011,47.011,0,0,1,11.712-33.965A45.663,45.663,0,0,1,266.7,231.831C281.654,231.741,291.788,237.171,295.238,240.751Z",
    transform: "translate(-89.724 -228.087)",
    fill: "#ffde14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(187.642 52.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M269.013,260.816c-1.3-2.109-3.565-3.586-5.681-4.789a23.49,23.49,0,0,0-6.764-2.764,18.193,18.193,0,0,0-6.069-.343c-1.635.23-5.129,1.247-5.045,3.394a.428.428,0,0,0,.536.409c.895-.247,1.487-1.127,2.288-1.581a7.753,7.753,0,0,1,2.973-.888,17.71,17.71,0,0,1,5.416.35,26.574,26.574,0,0,1,12.081,6.419c.136.122.371-.035.265-.207Z",
    transform: "translate(-245.452 -252.794)",
    fill: "#661615"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M245.967,264.865c-.939-.23.258-5.2,6.6-6.177a13.426,13.426,0,0,1,6.531.566c1.322.5,4.526,2.123,5.5,4.756a14.346,14.346,0,0,0-9.967-3C249.49,261.134,246.909,265.1,245.967,264.865Z",
    transform: "translate(-57.499 -192.087)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M253.735,258.834a2.792,2.792,0,0,1-.134,1.282,3.09,3.09,0,0,1-.745,1.16l-.449-.62a2.353,2.353,0,0,0,.855-.716A2.7,2.7,0,0,0,253.735,258.834Z",
    transform: "translate(-48.43 -191.668)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M254.829,258.914a2,2,0,0,1-.24,1.822,3.933,3.933,0,0,1-1.4,1.369l-.31-.7a3.215,3.215,0,0,0,1.4-.9A1.836,1.836,0,0,0,254.829,258.914Z",
    transform: "translate(-47.793 -191.563)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M255.223,259.808a1.354,1.354,0,0,1-.423,1.179,2.727,2.727,0,0,1-1.151.714l-.282-.747a2.535,2.535,0,0,0,1.193-.268A1.2,1.2,0,0,0,255.223,259.808Z",
    transform: "translate(-47.135 -190.355)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(142.71 52.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M226.615,261.023a26.523,26.523,0,0,1,12.079-6.419,18.114,18.114,0,0,1,5.277-.364,7.945,7.945,0,0,1,2.99.834c.853.458,1.477,1.39,2.41,1.649a.431.431,0,0,0,.538-.409c.082-2.1-3.3-3.126-4.909-3.373a17.988,17.988,0,0,0-6.207.322,23.259,23.259,0,0,0-6.614,2.68c-2.165,1.214-4.5,2.717-5.832,4.873-.1.171.127.331.268.207Z",
    transform: "translate(-226.321 -252.794)",
    fill: "#661615"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M246.713,264.865c.939-.23-.256-5.2-6.6-6.177a13.428,13.428,0,0,0-6.531.566c-1.32.5-4.526,2.123-5.5,4.756a14.341,14.341,0,0,1,9.965-3C243.19,261.134,245.771,265.1,246.713,264.865Z",
    transform: "translate(-81.243 -192.087)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M228.858,258.834a2.772,2.772,0,0,0,.132,1.282,3.09,3.09,0,0,0,.745,1.16l.449-.62a2.353,2.353,0,0,1-.855-.716A2.714,2.714,0,0,1,228.858,258.834Z",
    transform: "translate(-80.222 -191.668)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M228.173,258.914a2,2,0,0,0,.239,1.822,3.934,3.934,0,0,0,1.4,1.369l.31-.7a3.215,3.215,0,0,1-1.4-.9A1.836,1.836,0,0,1,228.173,258.914Z",
    transform: "translate(-81.271 -191.563)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M227.671,259.808a1.36,1.36,0,0,0,.425,1.179,2.712,2.712,0,0,0,1.148.714l.284-.747a2.542,2.542,0,0,1-1.2-.268A1.2,1.2,0,0,1,227.671,259.808Z",
    transform: "translate(-81.82 -190.355)",
    fill: "#661615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M251.522,250.928c-1.461,7.882,3.154,23.538,5.519,23.256s1.442-4.225,2.252-7.64c1.08,7.485.85,11.139,3.37,18.27.721,2.041,1.564,4.15,3.222,5.54,3.645-6.409,4.88-13.836,5.108-21.119.317-10.2.714-24.494-8.535-31.189-2.865-2.074-4.462-1.75-7.945-1.132",
    transform: "translate(-50.003 -221.859)",
    fill: "#ffde14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(214.026 20.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M256.744,239.618a60.546,60.546,0,0,1,6.132,20.24c.85,7.039.117,13.868-.9,20.834a.462.462,0,0,0,.89.247c2.419-6.792,2.525-14.517,1.59-21.591a55.3,55.3,0,0,0-6.884-20.214c-.31-.54-1.111-.064-.831.484Z",
    transform: "translate(-256.686 -238.897)",
    fill: "#ef7d00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(127.614 15.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M238.142,236.835a51.327,51.327,0,0,0-15.973,22.11c-3.025,8.455-3.434,18.366,1.238,26.321.247.416,1,.139.81-.343a36.232,36.232,0,0,1-.613-25.816,51.582,51.582,0,0,1,15.1-21.713c.39-.336-.169-.878-.559-.559Z",
    transform: "translate(-219.893 -236.738)",
    fill: "#ef7d00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(157.076 3.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M232.715,237.243a48.756,48.756,0,0,1,19.8-4.07,44.17,44.17,0,0,1,10.1,1.39c3.293.85,6.29,2.4,9.524,3.368.427.127.838-.486.46-.787-2.6-2.064-6.177-3.135-9.354-3.934a44.69,44.69,0,0,0-10.482-1.32,39.957,39.957,0,0,0-20.219,4.939c-.214.122-.068.514.174.413Z",
    transform: "translate(-232.438 -231.888)",
    fill: "#ef7d00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(165.81 13.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M236.961,247.831a45.609,45.609,0,0,1,13.007-7.807,46.534,46.534,0,0,1,6.973-2.095c2.372-.514,4.789-.709,7.168-1.167.47-.092.326-.77-.108-.8-4.988-.3-10.388,1.437-14.935,3.342a47.9,47.9,0,0,0-12.758,7.87c-.451.388.2,1.036.653.653Z",
    transform: "translate(-236.156 -235.932)",
    fill: "#ef7d00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(199.089 12.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M260.993,255.268c-.55-4.176-1.165-8.415-2.985-12.26-1.383-2.919-3.88-6.71-7.236-7.539a.351.351,0,0,0-.338.582c1.245,1.127,2.628,2.041,3.77,3.3a18.383,18.383,0,0,1,2.889,4.366,43.184,43.184,0,0,1,3.2,11.649c.068.392.756.305.7-.1Z",
    transform: "translate(-250.326 -235.46)",
    fill: "#ef7d00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M251.258,264.264a4.194,4.194,0,0,1-4.105,3.4h-3.774a4.2,4.2,0,0,1-4.105-3.4h-.9a5.2,5.2,0,0,0,5.172,4.848h3.452a5.2,5.2,0,0,0,5.169-4.848Z",
    transform: "translate(-67.363 -184.346)",
    fill: "#e29260"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(117.928 133.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271-2",
    "data-name": "Group 271",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M-2751.6-919.521a10.675,10.675,0,0,0-5.584-7.892q-1.832-13.157-3.666-26.315a20.778,20.778,0,0,0,4.025,1.252,38.456,38.456,0,0,0,.352,4.764,37.943,37.943,0,0,0,13.837,24.473c8.22,6.606,18.876,9.454,30.1,8.067,3.963-.508,20.248-7.852,23.374-10.9a39.805,39.805,0,0,0,8.186-11.62,31.355,31.355,0,0,0,9.745,9.756,36.08,36.08,0,0,0,22.34,5.64,36.061,36.061,0,0,0,20.773-9.961,31.946,31.946,0,0,0,6.593-9.1q.069.768.138,1.534a7.914,7.914,0,0,0,2.1,4.684c3.488,3.738,15.076,8.7,28.95,7.606,16.374-1.29,27.928-14.135,26.868-30.087-.353-5.182-3.294-9.336-7.4-12.8a7.954,7.954,0,0,0,2.745-6.533q-.56-8.07-1.121-16.141a7.791,7.791,0,0,0-2.043-4.722c-2.03-2.217-8.613-7.3-25.6-5.974-7.778.614-14.382,3.226-19.271,7.256a8.62,8.62,0,0,0-7.956-3.685q-10.583.939-21.162,1.957a8.667,8.667,0,0,0-6.937,4.617,8.667,8.667,0,0,0-7.707-3.17q-13.058,1.326-26.108,2.771a8.332,8.332,0,0,0-7.626,8.852c-7.238-4.833-16.778-7.358-28.276-5.937-4.274.511-20.75,8.148-23.927,11.5-.021.024-.043.05-.065.072a8.4,8.4,0,0,0-9.392-5.944q-26.85,3.646-53.646,7.806a8.332,8.332,0,0,0-7.229,9.322q1.358,8.583,2.719,17.166a8.323,8.323,0,0,0,9.659,6.673,19.1,19.1,0,0,0,9.218-4.283q1.993,13.135,3.986,26.269a10.671,10.671,0,0,0-3.106,9.157,8.257,8.257,0,0,0,9.5,6.739q12.705-1.909,25.423-3.7A8.255,8.255,0,0,0-2751.6-919.521Zm97.447-61.152a11.452,11.452,0,0,0,2.74-3.739,11.937,11.937,0,0,0,6.553,5.069q1.225,12.656,2.448,25.313c.342,3.545-2.536,6.1-3.86,6.719-1.431-.364-4.775-2.323-5.128-5.835Q-2652.772-966.909-2654.148-980.673Zm-66.268,10.561.278-.142a24.49,24.49,0,0,1,2.981,2.132c1.174,2.539,2.619,7.784,3.45,14.583,1.146,9.372.4,15.228-.353,17.519a20.9,20.9,0,0,1-2.222-1.907c-1.557-3.232-3.466-9.667-4.434-17.419C-2721.757-963.69-2721.016-968.308-2720.416-970.112Z",
    transform: "translate(2816.281 1023.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M-2535.087-932.8q10.322-.654,20.648-1.232a8.246,8.246,0,0,0,7.913-8.532,11.724,11.724,0,0,0-3.719-7.777q1.745.111,3.491.226a8.662,8.662,0,0,0,1.031.007c.241-.012.48-.034.718-.068l.754,1.678a10.164,10.164,0,0,0-1.478,5.891,8.249,8.249,0,0,0,8.767,7.653q12.535-.622,25.075-1.13a8.246,8.246,0,0,0,8.042-8.409,10.637,10.637,0,0,0-5.977-9.064q-10.1-23.24-20.506-46.4c.112-.207.234-.408.328-.625l.983-2.273a7.768,7.768,0,0,0-2.47-9.294q-6.743-5.215-13.536-10.4a8.927,8.927,0,0,0-5.877-1.781,9.028,9.028,0,0,0-4.234,1.307q-3.227,1.976-6.445,3.959a7.923,7.923,0,0,0-3.694,8.628q.894,3.634,1.786,7.271a7.853,7.853,0,0,0,1.693,3.251q-6.961,23.7-13.648,47.433c-5.267,1.925-8.865,6.983-8.518,12.152A8.245,8.245,0,0,0-2535.087-932.8Z",
    transform: "translate(2803.007 1024.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M-2330.365-955.079q-10.057-26.614-20.505-53.155a8.546,8.546,0,0,0-8.021-5.259,9.128,9.128,0,0,0-1.261.089q-6.125.866-12.245,1.758a8.431,8.431,0,0,0-6.821,5.463q-1.014,2.915-2.023,5.831a9.627,9.627,0,0,0-2.606-6c-.053-.065-5.77-6.525-11.988-6.436-5.758.081-10.973,5.78-11.543,6.429-2.238,2.529-3.129,5.2-2.665,7.925.016.094.033.188.053.281q1.989,9.51,3.954,19.021a8.042,8.042,0,0,0,3.241,4.907,8.706,8.706,0,0,0-2.446.755l-2.928,1.424a8.3,8.3,0,0,0-3.535,3.25q-2.855,4.87-5.688,9.746-.391-17.7-.783-35.408a10.458,10.458,0,0,0,4.221-9.087,8.35,8.35,0,0,0-8.714-7.451q-13.107.308-26.212.738a8.319,8.319,0,0,0-8.279,8.379,10.78,10.78,0,0,0,4.816,8.429q.694,20.293,1.389,40.586a10.681,10.681,0,0,0-4.136,8.734,8.247,8.247,0,0,0,8.636,7.8q23.758-.781,47.527-1.151a8.8,8.8,0,0,0,1.193-.11,8.7,8.7,0,0,0,1.2.074q10.336-.153,20.674-.228a8.243,8.243,0,0,0,8.314-8.137,11.722,11.722,0,0,0-3.335-7.949l3.476.4a8.7,8.7,0,0,0,1.029.057c.241,0,.481-.011.72-.032q.335.856.671,1.712a10.155,10.155,0,0,0-1.761,5.813,8.245,8.245,0,0,0,8.381,8.068q12.548-.011,25.095.09a8.244,8.244,0,0,0,8.439-8.008A10.639,10.639,0,0,0-2330.365-955.079Zm-62.668-17.591a8.808,8.808,0,0,0,2.438-.381q-.684,2.012-1.363,4.025a8.181,8.181,0,0,0-1.7-1.71l-2.562-1.889Z",
    transform: "translate(2798.775 1023.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M-1915.743-934.093q-1.08-1.21-2.161-2.419a8.685,8.685,0,0,0-5.152-2.771,8.852,8.852,0,0,0-1.754-.1q.488-3.17.975-6.342a17.305,17.305,0,0,0,2.33.525,8.324,8.324,0,0,0,9.655-6.68q1.354-8.584,2.707-17.167a8.332,8.332,0,0,0-7.235-9.317q-23.515-3.636-47.074-6.874a8.4,8.4,0,0,0-9.4,5.925c-4.2-5.161-10.948-8.661-19.624-9.764q-15.6-1.982-31.218-3.789a9.021,9.021,0,0,0-2.292.033,9.027,9.027,0,0,0-2.225-.553q-10.564-1.206-21.133-2.332a8.665,8.665,0,0,0-7.723,3.131,8.671,8.671,0,0,0-6.915-4.652q-13.061-1.324-26.128-2.526a9.136,9.136,0,0,0-1.6,0,9,9,0,0,0-1.572-.288q-26.952-2.449-53.937-4.383a9.113,9.113,0,0,0-1.139,0,9.115,9.115,0,0,0-1.127-.16q-10.594-.751-21.194-1.422a8.32,8.32,0,0,0-9.047,7.545,12.482,12.482,0,0,0,.057,2.22q-2.4-3.609-4.808-7.213a8.718,8.718,0,0,0-6.769-3.78q-11.327-.635-22.657-1.179a8.9,8.9,0,0,0-3.941.707,8.9,8.9,0,0,0-3.858-1.071q-23.706-1.073-47.425-1.751h0q-10.611-.3-21.224-.527a8.319,8.319,0,0,0-8.717,7.921,12.265,12.265,0,0,0,6.055,10.357q-1.8,4.686-3.58,9.376-2.59-6.99-5.207-13.975a10.063,10.063,0,0,0,1.916-5.773,8.317,8.317,0,0,0-8.428-8.227q-12.88-.19-25.764-.263a8.318,8.318,0,0,0-8.595,8.053,10.676,10.676,0,0,0,5.687,9.308q10.32,26.57,20.247,53.215a8.369,8.369,0,0,0,7.747,5.362,8.78,8.78,0,0,0,1.228-.069q5.974-.765,11.954-1.5a8.317,8.317,0,0,0,6.806-5.274q7.436-19.87,15.072-39.7-.393,14.44-.784,28.879a10.683,10.683,0,0,0-4.663,8.463,8.244,8.244,0,0,0,8.141,8.312q23.761.679,47.513,1.767a8.6,8.6,0,0,0,3.031-.409,8.579,8.579,0,0,0,2.975.691q10.329.5,20.657,1.067a8.247,8.247,0,0,0,8.812-7.6,11.506,11.506,0,0,0-7-11.471q.161-2.884.321-5.767,7.2,11.148,14.271,22.332a8.469,8.469,0,0,0,6.624,3.88q5.6.358,11.2.738a8.248,8.248,0,0,0,8.906-7.49q1.152-16.239,2.3-32.478a8.87,8.87,0,0,0,2,.384,19.024,19.024,0,0,0,9.922-2.115q-1,13.247-1.991,26.5a10.677,10.677,0,0,0-5.065,8.23,8.248,8.248,0,0,0,7.738,8.693q12.785.98,25.561,2.078a8.25,8.25,0,0,0,9.043-7.33,10.679,10.679,0,0,0-3.672-8.94q1.157-13.234,2.313-26.469a19.23,19.23,0,0,0,8.609,3.579q-.485,5.367-.971,10.734c-.8,8.885,2.5,17.388,9.241,23.978a36.072,36.072,0,0,0,20.75,10.008,36.091,36.091,0,0,0,22.355-5.587,30.292,30.292,0,0,0,12.238-14.7q-.338,2.951-.675,5.9a10.678,10.678,0,0,0-5.384,8.027,8.25,8.25,0,0,0,7.4,8.987q12.749,1.475,25.487,3.071a8.527,8.527,0,0,0,5.793-1.346,8.557,8.557,0,0,0,5.272,2.753q10.626,1.374,21.242,2.83c.15.021.3.027.443.039.146.028.289.061.437.082q23.6,3.245,47.161,6.9a8.273,8.273,0,0,0,9.494-6.44q1.519-7.906,3.044-15.813A7.919,7.919,0,0,0-1915.743-934.093Zm-325.116-22.7c0-.139.011-.278.017-.417.071.044.146.086.219.128Zm15.274-18.739a17.4,17.4,0,0,0,2.368.27,8.58,8.58,0,0,0,7.4-3.534q-.33,6.9-.66,13.8-1.116-1.01-2.235-2.02a8.655,8.655,0,0,0-5.408-2.2,8.791,8.791,0,0,0-1.75.1Q-2225.728-972.325-2225.585-975.531Zm52.859-10.218L-2174-987.68a14.881,14.881,0,0,0,1.348.725Q-2172.689-986.352-2172.726-985.749Zm117.308,33.944c-.376,3.542-3.708,5.464-5.13,5.807-1.331-.644-4.214-3.234-3.855-6.745q1.417-13.759,2.83-27.52a11.435,11.435,0,0,0,3.435-3.113,11.937,11.937,0,0,0,5.4,6.281Q-2054.076-964.449-2055.418-951.8Zm83.3.283q-.832,6.117-1.664,12.233a46.218,46.218,0,0,0-4.083-6.77A23.939,23.939,0,0,0-1972.121-951.521Zm31.041,22.776c.021-.137.041-.274.062-.411.068.05.135.1.2.15Z",
    transform: "translate(2793.193 1023.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M-2695.339-854.472q-13.142-25.127-26.667-50.132a8.334,8.334,0,0,0-8.435-4.206,8.728,8.728,0,0,0-1.209.247q-5.813,1.628-11.617,3.282a8.27,8.27,0,0,0-5.892,6.273q-5.073,25.336-9.841,50.679c-4.958,2.323-8.041,7.641-7.277,12.765a8.138,8.138,0,0,0,9.242,6.82q9.975-1.447,19.958-2.819a8.137,8.137,0,0,0,6.987-9.113,11.878,11.878,0,0,0-4.251-7.464l3.411-.044a8.173,8.173,0,0,0,1-.073q.349-.047.691-.123l.87,1.614a10.335,10.335,0,0,0-.952,5.985,8.134,8.134,0,0,0,9.141,6.948q12.125-1.588,24.26-3.066a8.131,8.131,0,0,0,7.122-9A10.678,10.678,0,0,0-2695.339-854.472Z",
    transform: "translate(2813.85 1018.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M-2536.225-921c-3.074-2.271-10.613-5.973-26.4-4.87-4.175.276-20.549,7-23.783,10.157a39.326,39.326,0,0,0-4.545,5.277q-.157-1.931-.313-3.863a8.2,8.2,0,0,0-8.977-7.375q-23.027,1.939-46.029,4.263h0q-10.291,1.04-20.576,2.157a8.2,8.2,0,0,0-7.407,8.954,12.316,12.316,0,0,0,7.182,9.508q-1.135,4.874-2.256,9.75-3.4-6.605-6.826-13.2a10.252,10.252,0,0,0,1.11-5.967,8.2,8.2,0,0,0-9.2-7.1q-12.476,1.436-24.94,2.984a8.206,8.206,0,0,0-7.272,9.068,10.71,10.71,0,0,0,6.7,8.515q13.4,25.05,26.417,50.223a8.154,8.154,0,0,0,8.172,4.343,8.375,8.375,0,0,0,1.178-.224q5.672-1.511,11.353-3a8.146,8.146,0,0,0,5.895-6.088q4.63-20.644,9.464-41.275,1.473,14.37,2.945,28.739a10.774,10.774,0,0,0-3.417,8.982,8.134,8.134,0,0,0,8.926,7.216q23.027-2.327,46.081-4.257a8.132,8.132,0,0,0,7.466-8.472q-.037-.763-.074-1.528c7.486,6.382,17.146,9.324,28.111,8.552,12.593-.887,21.311-5.511,24.969-9.239a8.078,8.078,0,0,0,2.3-6.136q-.464-7.734-.927-15.468a8.137,8.137,0,0,0-8.7-7.57c-7.747.487-12.875,6.507-15.191,9.991q-2.125,3.139-4.24,6.282c-.289-.29-.546-.564-.739-.8-1.3-3.183-2.926-10.515-3.436-17.622-.569-7.929.248-12.445.9-14.41q3.162,3.226,6.309,6.459c1.98,2.036,7.972,8.224,16.244,7.7a8.189,8.189,0,0,0,7.74-8.579q-.485-8.076-.968-16.151A7.979,7.979,0,0,0-2536.225-921Zm-75.867,53.315c-.011-.139-.025-.277-.037-.416.076.034.15.068.227.1C-2611.964-867.9-2612.028-867.795-2612.092-867.689Zm12.35-20.518c.455.026.914.027,1.379.013a40.4,40.4,0,0,0,.133,4.361c.05.6.116,1.185.189,1.772a8.458,8.458,0,0,0-1.159.246Q-2599.471-885.009-2599.742-888.207Z",
    transform: "translate(2811.418 1019.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M-2340.369-890.865q-1.254-.993-2.511-1.984a8.282,8.282,0,0,0-5.107-1.777,8.319,8.319,0,0,0-3.593.8q-1.438.682-2.875,1.365a8.157,8.157,0,0,0-3.5,3.177q-2.87,4.812-5.723,9.629-.032-17.709-.067-35.416a10.556,10.556,0,0,0,4.285-9,8.213,8.213,0,0,0-8.333-7.626q-12.757.043-25.516.2a8.2,8.2,0,0,0-8.216,8.205c0,.089.017.174.021.263-6.579-5.75-15.724-9.372-27.238-9.08-4.18.089-20.831,6.068-24.211,9.089a41.329,41.329,0,0,0-5.688,6.208q-.03-.826-.06-1.652a7.934,7.934,0,0,0-1.841-4.789c-1.905-2.285-8.146-7.589-24.708-6.842-17.774.817-29.527,12.75-28.588,28.77a20.68,20.68,0,0,0,4.911,12.156,8.018,8.018,0,0,0-2.97,6.684q.439,7.735.875,15.47a8.057,8.057,0,0,0,1.9,4.753c3.275,3.857,14.381,9.213,27.9,8.6,10.854-.5,19.668-6.41,24.064-15.168.65.771,1.326,1.523,2.039,2.243A37.932,37.932,0,0,0-2426.8-855.6c3.877-.115,20.3-5.826,23.613-8.554.913-.762,1.775-1.569,2.609-2.4-.029.344-.05.69-.045,1.041a8.127,8.127,0,0,0,8.245,7.974q23.114-.291,46.23-.184a8.129,8.129,0,0,0,8.176-7.818q.331-9.372.663-18.743A8.028,8.028,0,0,0-2340.369-890.865Zm-85.95,14.37a20.739,20.739,0,0,1-1.968-2.117c-1.2-3.369-2.442-9.96-2.649-17.77-.223-8.405.926-12.928,1.674-14.665l.283-.113a23.936,23.936,0,0,1,2.682,2.414c.9,2.642,1.8,8,1.965,14.851C-2424.106-884.457-2425.382-878.7-2426.319-876.5Z",
    transform: "translate(2801.54 1019.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M-2207.02-928.026q-26.286-1.353-52.587-2.205a8.506,8.506,0,0,0-3.152.5,8.517,8.517,0,0,0-3.115-.692q-23.081-.7-46.169-1.006a8.2,8.2,0,0,0-8.426,7.99,10.89,10.89,0,0,0,4.3,8.668q-.243,20.29-.487,40.581a10.772,10.772,0,0,0-4.412,8.534,8.127,8.127,0,0,0,8.035,8.186q23.112.311,46.221,1.018a8.129,8.129,0,0,0,8.375-7.566q.53-8.033,1.061-16.068a8.026,8.026,0,0,0-2.645-6.49q-1.182-1.067-2.367-2.133a8.266,8.266,0,0,0-5.289-2.113,8.324,8.324,0,0,0-1.7.124q.094-3.206.188-6.414a16.572,16.572,0,0,0,2.307.233,8.4,8.4,0,0,0,3.114-.5,8.37,8.37,0,0,0,3.077.693,18.11,18.11,0,0,0,9.562-2.51l-.952,26.553a10.772,10.772,0,0,0-4.615,8.426,8.126,8.126,0,0,0,7.839,8.375q12.453.465,24.9,1.045a8.128,8.128,0,0,0,8.514-7.689,10.784,10.784,0,0,0-3.895-8.783q.639-13.27,1.275-26.539a18.13,18.13,0,0,0,9.319,3.3,8.19,8.19,0,0,0,8.673-7.641l.947-17.354A8.2,8.2,0,0,0-2207.02-928.026Zm-76.767,49.886c0-.139.008-.278.011-.417l.215.125Z",
    transform: "translate(2792.14 1019.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M-1976.677-908.335c-4.15-.573-21.567,2.7-25.389,5.154a41.449,41.449,0,0,0-7.04,5.655c-2.9-8.9-11.106-15.008-22.965-16.351q-15.2-1.721-30.417-3.273a8.509,8.509,0,0,0-4.1.591,8.51,8.51,0,0,0-3.9-1.4q-23-2.279-46.035-4.171a8.2,8.2,0,0,0-8.96,7.392,10.883,10.883,0,0,0,3.7,8.942q-1.093,13.528-2.186,27.056-6.007-20.7-12.242-41.384a8.324,8.324,0,0,0-7.406-5.817,8.752,8.752,0,0,0-1.232,0q-6.012.427-12.02.88a8.257,8.257,0,0,0-7.022,4.961q-10.049,23.8-19.8,47.664c-5.313,1.279-9.393,5.868-9.678,11.041a8.13,8.13,0,0,0,7.662,8.539q10.041.588,20.078,1.251a8.129,8.129,0,0,0,8.664-7.522,11.888,11.888,0,0,0-2.656-8.166l3.344.643a8.28,8.28,0,0,0,.995.13c.234.016.468.022.7.019q.264.877.526,1.755a10.371,10.371,0,0,0-2.134,5.671,8.13,8.13,0,0,0,7.544,8.645q12.177.882,24.35,1.875c.291.023.577.03.862.024a8.331,8.331,0,0,0,.854.116q23.057,1.895,46.087,4.188a8.165,8.165,0,0,0,3.319-.359,8.168,8.168,0,0,0,3.188,1.014q12.411,1.265,24.813,2.647a8.148,8.148,0,0,0,5.62-1.441,8.193,8.193,0,0,0,5.155,2.664q10.346,1.194,20.685,2.469a8.166,8.166,0,0,0,7.593-3.271,39.229,39.229,0,0,0,19.311,8.024c3.855.5,21.013-2.548,24.72-4.718a39.435,39.435,0,0,0,18.939-28.249C-1940.361-884-1950.957-904.878-1976.677-908.335Zm-115.287,41.316.038-.415c.068.048.138.093.207.139Zm15.248-11.545q.314-3.193.627-6.387a16.5,16.5,0,0,0,2.287.391,8.362,8.362,0,0,0,4.148-.645q-.428,4.259-.856,8.519a8.3,8.3,0,0,0-4.5-1.885A8.4,8.4,0,0,0-2076.716-878.565Zm93.675,25.53a20.8,20.8,0,0,1-1.614-2.4c-.656-3.517-.846-10.22.18-17.966,1.1-8.336,2.955-12.62,3.969-14.217l.3-.068a23.97,23.97,0,0,1,2.272,2.807c.473,2.75.52,8.187-.4,14.975C-1979.6-860.547-1981.765-855.066-1983.041-853.035Z",
    transform: "translate(2785.916 1019.546)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M-2783.011-916.443a3.287,3.287,0,0,0-1.956,3.15q12.741-1.915,25.5-3.711a3.288,3.288,0,0,0-2.771-2.462l-2.133-.475q-3.556-24.959-7.109-49.92l3.766-.534q2.965,3.516,5.918,7.036c2.08,2.476,6.339,5,10.355,4.453q-1.169-8.611-2.338-17.221-26.774,3.636-53.493,7.785,1.333,8.587,2.667,17.173c4.007-.623,7.375-4.254,8.663-7.22q1.827-4.218,3.668-8.432l3.764-.562q3.706,24.939,7.413,49.876Q-2782.057-916.975-2783.011-916.443Z",
    transform: "translate(2815.842 1021.992)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M-2710.043-922.144c2.191-.284,16.7-6.856,18.394-8.505a31.011,31.011,0,0,0,9.116-25.6c-1.653-14.964-14.273-28.335-34.917-25.793-2.44.288-17.006,7.149-18.6,8.838a30.486,30.486,0,0,0-8.534,25.4C-2742.517-932.7-2729.207-919.766-2710.043-922.144Zm-13.253-52.613a34.617,34.617,0,0,1,6.35-3.208c2.431-.3,9.608,4.775,10.536,6.477,1.984,3.641,3.7,10.421,4.6,17.986,1.194,10.031.794,20.251-2.479,24.269-.7.859-5.71,3.112-6.238,3.178-2.465.3-8.7-5.039-9.523-6.572-2.36-4.446-4.546-12.365-5.6-20.6C-2726.815-962.313-2726.46-970.9-2723.3-974.756Z",
    transform: "translate(2812.799 1022.295)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M-2675.762-982.845l2.243.529q1.771,16.212,3.541,32.424c1.588,14.29,16.521,21.194,27.005,20.155,10.483-1.062,23.745-10.793,22.464-25.112q-1.427-15.644-2.855-31.288l3.436-1.171c2.026-.7,3.466-1.857,3.255-4.244q-10.553.936-21.1,1.951c.229,2.386,1.858,3.261,3.978,3.576q1.8.26,3.592.521l2.931,31.281c.812,8.778-6.8,15.172-11.489,15.638-4.6.448-13.4-4.33-14.316-13.1q-1.673-16.224-3.344-32.445.995-.491,1.991-.979c.866-.434,2.3-1.525,2.056-3.05q-13.024,1.323-26.035,2.763C-2678.242-983.864-2676.7-983.088-2675.762-982.845Z",
    transform: "translate(2809.56 1022.744)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M-2573.966-950.048c.5,6.573-3.086,10.966-6.447,11.23-.528.039-7.25-2.687-7.86-3.58q-2.921-4.1-5.856-8.193c-1.722-2.435-6-5.34-10.011-4.993q.669,7.718,1.337,15.437c1.188,1.275,9.955,5.917,22.053,4.964,10.415-.825,19.985-8.626,19.088-21.436-.793-11.836-32.1-18.276-32.706-25.134-.416-5.034,3.039-9.357,6.919-9.665.539-.044,3.807,1.073,4.508,1.963q3.277,4.211,6.532,8.427c2.011,2.68,6,5.384,10.034,5.092q-.585-8.069-1.17-16.137c-1.179-1.284-6.385-4.186-18.487-3.237-12.475.985-21.732,8.506-20.637,20.954C-2605.3-959.229-2574.285-954.626-2573.966-950.048Z",
    transform: "translate(2806.067 1022.936)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M-2518.408-944.791q-2.333-.381-4.669-.758,1.77-6.193,3.56-12.383,6.9.418,13.8.87,1.25-1.7,2.5-3.387-1.523-1.808-3.05-3.614-6.067,1.176-12.128,2.378,2.99-10.331,6.033-20.656l1.887-.1q8.476,18.578,16.752,37.205l-.956.475c-.954.476-2.342,1.143-2.256,2.854q12.573-.623,25.148-1.133c-.068-1.71-1.783-2.411-2.5-2.639l-1.437-.369q-12.083-27.684-24.606-55.262-6.062,1.159-12.115,2.344-8.012,26.968-15.669,53.979-1.792.538-3.582,1.078c-2.013.554-3.58,2.455-3.472,4.164q10.352-.658,20.709-1.237C-2514.555-942.694-2516.345-944.48-2518.408-944.791Z",
    transform: "translate(2802.578 1023.22)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M-2496.529-1003.188q.488-1.139.978-2.276-6.74-5.2-13.53-10.372-3.223,1.97-6.436,3.949.885,3.639,1.764,7.277Q-2505.135-1003.926-2496.529-1003.188Z",
    transform: "translate(2801.619 1023.928)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M-2443.981-946.773a3.28,3.28,0,0,0-2.3,2.9q23.829-.782,47.666-1.154.12-9.377.243-18.754-1.309-.965-2.62-1.928-1.461.709-2.921,1.419-4.075,6.922-8.108,13.853a12.177,12.177,0,0,1-7.055,2.209q-3.037-.786-6.077-1.567-.613-24.434-1.228-48.868l2.059-.822c.895-.364,2.41-1.341,2.282-2.88q-13.07.308-26.137.737c.05,1.54,1.528,2.433,2.442,2.747l2.192.7q.789,25.286,1.579,50.571Z",
    transform: "translate(2798.336 1023.271)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M-2390.294-980.307q1.668-9.569,3.36-19.135c.258-1.2-4.582-4.823-5.942-4.8s-6.1,3.774-5.893,4.97q1.96,9.515,3.9,19.033Q-2392.582-980.276-2390.294-980.307Z",
    transform: "translate(2795.928 1023.363)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M-2332.482-948.158l-1.417-.438q-10.721-28.238-21.887-56.391-6.108.862-12.21,1.751-9.31,26.547-18.266,53.154l-3.628.9c-2.035.456-3.695,2.278-3.669,3.99q10.367-.153,20.736-.228c-.013-1.712-1.713-3.583-3.757-3.994q-2.313-.494-4.626-.983,2.069-6.1,4.155-12.2,6.873.753,13.738,1.54,1.33-1.631,2.664-3.262-1.433-1.879-2.87-3.757-6.116.88-12.226,1.786,3.488-10.174,7.027-20.339l1.889-.01q7.559,18.968,14.918,37.975l-.976.428c-.975.428-2.394,1.029-2.392,2.74q12.583-.011,25.168.09C-2330.095-947.113-2331.774-947.9-2332.482-948.158Z",
    transform: "translate(2795.674 1023.399)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M-2331.259-1000.388l1.443.438q10.917,28.244,21.389,56.568,5.99-.766,11.988-1.508,9.768-26.313,19.89-52.556l3.726-.758c2.088-.372,3.855-2.118,3.905-3.83q-10.581-.3-21.164-.526c-.037,1.712,1.643,3.544,3.708,4.106q2.381.609,4.761,1.223-6.934,17.86-13.7,35.752l-1.872-.036q-7.04-19.142-14.282-38.246l1-.415c1-.415,2.454-.992,2.479-2.7q-12.844-.19-25.69-.262C-2333.691-1001.431-2331.979-1000.651-2331.259-1000.388Z",
    transform: "translate(2792.755 1023.309)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M-2264.856-946.97a3.286,3.286,0,0,0-2.475,2.755q23.83.681,47.652,1.771.634-8.028,1.27-16.053l-2.4-2.166q-1.547.616-3.091,1.234-4.432,5.375-8.831,10.763a12.17,12.17,0,0,1-7.179,1.772q-2.982-.972-5.969-1.936.395-10.908.791-21.817,4.159.151,8.317.314.773,2,1.543,4a5.739,5.739,0,0,0,4.334,3.347q.379-9.152.759-18.3a5.746,5.746,0,0,0-4.617,2.982q-.93,1.935-1.857,3.868-4.165-.163-8.33-.314.405-11.208.813-22.415,5.508.2,11.015.421,2.287,3.818,4.563,7.641c1.688,2.812,5.33,6.052,9.371,6.235q.393-8.681.786-17.361-23.637-1.07-47.289-1.745a3.421,3.421,0,0,0,2.356,2.979l2.058.747q-.763,25.286-1.526,50.572Z",
    transform: "translate(2789.521 1023.252)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M-2193.516-945.109q-2.011-.623-4.024-1.244.988-18.765,1.978-37.53,14.476,22.067,28.473,44.278,5.618.358,11.236.74l3.579-52.7q2.379-.354,4.758-.7c2.1-.284,3.714-1.283,3.886-3.675q-10.564-.749-21.133-1.418c-.152,2.392,1.318,3.515,3.359,4.161l4.081,1.3-2.106,31.862-.445-.029q-12.513-19.313-25.4-38.514-11.294-.634-22.593-1.176c-.074,1.538,1.327,2.548,2.212,2.936l2.129.875q1.641,2.483,3.276,4.966-1.128,22.187-2.258,44.374-2.332.4-4.662.8c-2.062.327-3.623,1.367-3.736,3.76q10.359.5,20.716,1.071C-2190.055-943.376-2191.5-944.486-2193.516-945.109Z",
    transform: "translate(2786.77 1023.144)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M-2129.076-983.343q2.72-3.7,5.451-7.4l3.787.294q-1.965,25.135-3.931,50.27l-2.1.61a3.283,3.283,0,0,0-2.605,2.632q12.823.983,25.636,2.083a3.284,3.284,0,0,0-2.146-3.019l-1.97-.939q2.117-25.123,4.236-50.246l3.784.322q2.1,4.089,4.188,8.182c1.469,2.877,5.052,6.288,9.084,6.655q.787-8.654,1.572-17.308-26.875-2.442-53.784-4.37-.62,8.667-1.242,17.335C-2135.077-977.953-2130.991-980.74-2129.076-983.343Z",
    transform: "translate(2783.27 1022.94)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M-2075.864-987.65l2.09.969q-1.519,16.238-3.039,32.476c-1.313,14.317,11.926,24.078,22.406,25.165,10.481,1.063,25.434-5.807,27.053-20.092q1.742-15.611,3.484-31.225l3.6-.458c2.126-.277,3.771-1.122,4.043-3.5q-10.533-1.2-21.073-2.325c-.253,2.384,1.167,3.567,3.181,4.3l3.415,1.232q-1.7,15.616-3.409,31.232c-.965,8.762-9.713,13.5-14.4,13.013-4.595-.483-12.263-6.934-11.4-15.706q1.618-16.228,3.237-32.457l2.147-.558c.936-.251,2.56-1.032,2.625-2.575q-13.022-1.318-26.053-2.517C-2078.088-989.145-2076.732-988.075-2075.864-987.65Z",
    transform: "translate(2780.288 1022.701)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M-2012.6-928.576a3.282,3.282,0,0,0-2.708,2.529q12.785,1.48,25.561,3.078a3.286,3.286,0,0,0-2.03-3.1l-1.935-1.015q3.071-24.852,6.14-49.7,2.47.305,4.94.615a20.072,20.072,0,0,1,4.751,3.534c.624,1.546.948,4,.209,9.778-.87,6.795-3.335,11.224-7.429,10.709l-.979-.123-2.035,1.817q.764,1.13,1.525,2.261c5.866.738,3.639,16.248,7.94,26.641q10.656,1.377,21.305,2.838a3.286,3.286,0,0,0-1.995-3.124l-1.835-1.026c-3.6-13.793-9.564-21.409-16.361-24.784,8.047-.781,15.79-5.181,16.865-13.157,1.452-10.773-5.526-17.421-16.865-18.862q-15.557-1.975-31.13-3.778c-.178,1.531,1.154,2.633,2.014,3.078l2.067,1.017q-2.948,25.126-5.9,50.251Z",
    transform: "translate(2777.235 1022.349)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M-1905.316-929.525l-3.213.892q-5,4.864-9.962,9.745a12.218,12.218,0,0,1-7.345.985q-2.868-1.289-5.741-2.571,1.57-10.8,3.14-21.6,4.128.6,8.256,1.212.555,2.073,1.106,4.146a5.746,5.746,0,0,0,3.959,3.8q1.364-9.058,2.728-18.116a5.759,5.759,0,0,0-4.922,2.466q-1.134,1.822-2.269,3.644-4.134-.614-8.268-1.215,1.612-11.1,3.226-22.2,5.468.795,10.932,1.611,1.869,4.045,3.725,8.091c1.379,2.978,4.658,6.595,8.667,7.214q1.328-8.587,2.656-17.175-23.448-3.624-46.939-6.855a3.423,3.423,0,0,0,2.027,3.218q.985.481,1.969.965l-6.972,50.113-2.132.481a3.286,3.286,0,0,0-2.763,2.47q23.672,3.255,47.3,6.919,1.5-7.912,3-15.822Z",
    transform: "translate(2774.219 1021.959)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M-2699.125-846.949l-1.425-.257q-14-26.654-28.426-53.168-5.8,1.624-11.583,3.272-5.578,27.495-10.8,55-1.7.673-3.392,1.35a4.519,4.519,0,0,0-3.031,4.417q10-1.453,20.019-2.829a4.614,4.614,0,0,0-4.148-3.488q-2.3-.2-4.6-.395,1.211-6.308,2.44-12.615,6.744-.117,13.481-.2,1.076-1.785,2.154-3.57-1.627-1.684-3.259-3.366-5.8,1.641-11.59,3.307,2.057-10.526,4.168-21.051l1.826-.247q9.757,17.859,19.321,35.782l-.888.547c-.887.548-2.182,1.321-1.958,3.018q12.16-1.592,24.332-3.074C-2696.684-846.213-2698.408-846.779-2699.125-846.949Z",
    transform: "translate(2813.431 1018.299)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M-2661.433-902.756q2.38.3,4.756.613-4.407,18.587-8.65,37.185l-1.812.2q-9.259-18.094-18.716-36.128l.914-.537c.914-.537,2.244-1.294,2.05-2.995q-12.439,1.431-24.869,2.976c.212,1.7,1.968,2.257,2.7,2.427l1.451.252q14.191,26.634,27.947,53.4,5.687-1.515,11.385-3.006,6.056-27.326,12.468-54.629,1.749-.612,3.5-1.222c1.969-.633,3.454-2.588,3.282-4.292q-10.26,1.037-20.516,2.151C-2665.356-904.657-2663.5-903.052-2661.433-902.756Z",
    transform: "translate(2810.991 1018.696)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M-2596.022-871.815q-3.59,5.892-7.147,11.793a11.626,11.626,0,0,1-6.7,2.665q-3-.586-6.01-1.165-1.014-10.867-2.028-21.736,4.036-.377,8.071-.741,1,1.886,2,3.774c.737,1.4,2.879,2.923,4.612,2.77q-.8-9.125-1.607-18.25a5.6,5.6,0,0,0-4.075,3.542q-.651,2.036-1.3,4.07-4.042.365-8.083.743-1.042-11.167-2.084-22.333,5.345-.5,10.691-.976,2.7,3.5,5.383,7c1.989,2.575,5.919,5.327,9.843,5q-.729-8.658-1.458-17.318-22.96,1.933-45.895,4.251a3.4,3.4,0,0,0,2.659,2.658l2.083.479q2.5,25.174,5.006,50.348l-1.9.964a3.255,3.255,0,0,0-2.036,3.044q23.095-2.334,46.22-4.27-.414-8.04-.824-16.081-1.3-.923-2.594-1.844Q-2594.61-872.624-2596.022-871.815Z",
    transform: "translate(2807.776 1018.914)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M-2574.066-909.586a31.541,31.541,0,0,0-9.479,25.487c1.266,15.2,12.724,28.3,32.209,26.915,11.431-.8,17.9-4.973,19.694-6.8q-.486-7.732-.974-15.465c-3.9.245-7.153,3.8-8.888,6.409q-3.6,5.3-7.172,10.611a6.043,6.043,0,0,1-2.937,1.321c-2.406.167-8.189-5.507-8.917-7.083-1.854-3.984-3.8-12.595-4.422-20.875-.684-9.135.081-17.692,3.343-21.364a33.063,33.063,0,0,1,6.321-2.856c1.933-.136,4.033,2.207,4.408,2.525q3.7,3.78,7.374,7.567c2.266,2.338,5.8,5.452,9.724,5.2q-.509-8.073-1.017-16.147c-2.032-1.5-7.939-4.146-20.777-3.248C-2557.959-917.237-2572.436-911.183-2574.066-909.586Z",
    transform: "translate(2804.941 1019.137)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M-2492.98-908.237c-.252-5.043,3.241-9.246,7.023-9.421.528-.025,3.666,1.2,4.323,2.116q3.053,4.319,6.089,8.645c1.875,2.747,5.666,5.585,9.6,5.431q-.319-8.083-.638-16.167c-1.106-1.322-6.077-4.4-17.873-3.865-12.157.557-21.39,7.755-20.7,20.232.866,15.166,30.869,20.83,31.036,25.414.28,6.585-3.338,10.853-6.61,11-.517.021-6.962-2.934-7.528-3.848q-2.711-4.2-5.438-8.389c-1.6-2.492-5.669-5.543-9.575-5.334q.412,7.737.827,15.473c1.115,1.315,9.491,6.256,21.275,5.717,10.145-.467,19.687-7.938,19.211-20.771C-2462.372-893.856-2492.6-901.36-2492.98-908.237Z",
    transform: "translate(2801.116 1019.332)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M-2425.678-923.607c-2.386.047-17.112,5.443-18.811,6.967a30.82,30.82,0,0,0-10.628,24.436c.585,15.237,12.232,29.417,30.972,28.933,2.145-.068,16.779-5.183,18.575-6.659a31.359,31.359,0,0,0,11.223-24.585C-2394.534-909.569-2405.476-924.108-2425.678-923.607Zm7.76,53.847c-.761.787-5.81,2.536-6.328,2.551-2.411.059-7.93-5.87-8.586-7.477-1.863-4.656-3.232-12.751-3.479-21.052-.273-9.157.877-17.671,4.3-21.193a32.905,32.905,0,0,1,6.44-2.568c2.38-.064,8.84,5.7,9.578,7.48,1.576,3.819,2.6,10.733,2.756,18.352C-2413.029-883.568-2414.377-873.437-2417.917-869.759Z",
    transform: "translate(2798.676 1019.432)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M-2344.7-884.741q-4.1,6.838-8.157,13.687a11.605,11.605,0,0,1-6.9,2.065q-2.937-.847-5.878-1.689-.12-24.441-.241-48.883l2.02-.779c.877-.346,2.37-1.294,2.277-2.834q-12.722.043-25.442.2a3.319,3.319,0,0,0,2.323,2.8l2.119.747q.278,25.3.556,50.592l-1.976.792a3.257,3.257,0,0,0-2.294,2.853q23.184-.291,46.369-.185.3-9.373.607-18.745-1.254-.992-2.51-1.98Z",
    transform: "translate(2795.356 1019.411)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M-2270.491-881.044q-4.236,5.445-8.437,10.9a11.609,11.609,0,0,1-6.956,1.885q-2.915-.925-5.832-1.843.23-10.913.46-21.826,4.047.086,8.095.183.779,1.989,1.557,3.977c.574,1.471,2.527,3.231,4.262,3.278q.242-9.158.481-18.315a5.6,5.6,0,0,0-4.448,3.055q-.877,1.948-1.753,3.9-4.053-.1-8.106-.183.237-11.212.473-22.425,5.362.113,10.723.247,2.28,3.783,4.546,7.568c1.682,2.786,5.269,5.967,9.2,6.086q.263-8.685.523-17.372-23.013-.693-46.033-1a3.4,3.4,0,0,0,2.336,2.943l2.012.714q-.38,25.3-.759,50.59l-2,.741a3.255,3.255,0,0,0-2.368,2.792q23.182.311,46.36,1.021.5-8.035,1.013-16.07l-2.365-2.128Z",
    transform: "translate(2791.723 1019.399)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M-2257.324-904.3c3.934.126,7.8-2.821,9.565-5.5q2.506-3.807,5.023-7.611l3.691.141q-.981,25.193-1.961,50.386l-2.014.693a3.257,3.257,0,0,0-2.434,2.735q12.491.467,24.979,1.048a3.26,3.26,0,0,0-2.2-2.93l-1.948-.859q1.133-25.187,2.266-50.373l3.689.168q2.192,4,4.369,8c1.534,2.816,5.142,6.078,9.072,6.281l.894-17.356q-26.208-1.35-52.433-2.2Q-2257.043-912.985-2257.324-904.3Z",
    transform: "translate(2789.033 1019.337)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M-2125.33-859.119l-1.343-.537q-8.336-28.924-17.121-57.8-6,.425-11.986.876-10.978,25.812-21.607,51.707l-3.586.64a4.522,4.522,0,0,0-3.851,3.717q10.071.591,20.139,1.255a4.611,4.611,0,0,0-3.354-4.251q-2.209-.658-4.417-1.312,2.452-5.934,4.922-11.867,6.615,1.243,13.221,2.517,1.411-1.533,2.824-3.063-1.252-1.978-2.51-3.953-6,.442-12,.909,4.126-9.9,8.306-19.783l1.834.125Q-2149.9-880.48-2144.15-861l-.979.358c-.979.358-2.4.855-2.522,2.563q12.215.885,24.423,1.881C-2123.09-857.906-2124.662-858.807-2125.33-859.119Z",
    transform: "translate(2785.498 1019.132)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M-2075.214-868.836q-4.6,5.141-9.173,10.3a11.617,11.617,0,0,1-7.076,1.4q-2.846-1.122-5.7-2.237.977-10.872,1.956-21.744,4.036.364,8.07.738.643,2.038,1.282,4.074c.472,1.507,2.3,3.4,4.032,3.563q.868-9.119,1.736-18.238a5.6,5.6,0,0,0-4.651,2.743q-1.011,1.882-2.018,3.766-4.042-.375-8.083-.738,1-11.171,2.008-22.34,5.346.481,10.69.983,2.018,3.93,4.023,7.863c1.488,2.895,4.852,6.313,8.772,6.7q.858-8.647,1.713-17.294-22.936-2.273-45.9-4.16a3.4,3.4,0,0,0,2.129,3.1l1.961.85q-2.113,25.21-4.226,50.419l-2.043.6a3.254,3.254,0,0,0-2.555,2.624q23.125,1.9,46.225,4.2,1.055-7.98,2.113-15.963l-2.216-2.285Z",
    transform: "translate(2782.253 1018.937)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M-2008.334-847.481l-1.794-.995c-3.641-13.724-9.515-21.236-16.161-24.5,7.819-.916,15.309-5.444,16.274-13.434,1.305-10.791-5.551-17.318-16.6-18.57q-15.157-1.715-30.329-3.264a3.322,3.322,0,0,0,1.991,3.044l2.023.984q-2.608,25.163-5.215,50.326l-2.055.561a3.256,3.256,0,0,0-2.607,2.573q12.448,1.27,24.888,2.655a3.257,3.257,0,0,0-2.005-3.064l-1.892-.984q2.733-24.892,5.465-49.783,2.406.264,4.812.533a19.456,19.456,0,0,1,4.658,3.453c.623,1.535.962,3.988.3,9.77-.777,6.805-3.131,11.274-7.118,10.827l-.953-.107-1.961,1.85q.755,1.117,1.506,2.234c5.716.64,3.706,16.18,7.993,26.5q10.376,1.2,20.747,2.477A3.257,3.257,0,0,0-2008.334-847.481Z",
    transform: "translate(2779.55 1018.682)",
    fill: "#85a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M-1968.456-899c-2.37-.33-17.788,2.673-19.711,3.91a30.8,30.8,0,0,0-14.367,22.453c-1.823,15.139,7.463,30.978,26.082,33.46,2.133.272,17.423-2.469,19.434-3.642a31.339,31.339,0,0,0,14.987-22.5C-1939.84-880.223-1948.386-896.311-1968.456-899Zm-.809,54.4c-.878.656-6.151,1.588-6.664,1.52-2.395-.322-6.922-7.048-7.318-8.738-1.109-4.893-1.188-13.1-.123-21.339,1.175-9.084,3.652-17.312,7.593-20.249a33.027,33.027,0,0,1,6.777-1.52c2.364.313,7.852,7.02,8.3,8.9.957,4.019.878,11.01-.165,18.557C-1962.25-857.468-1965.18-847.679-1969.264-844.605Z",
    transform: "translate(2776.623 1018.233)",
    fill: "#85a34c"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileTousALaventureAvecSolEtAero);
export default __webpack_public_path__ + "static/media/tile-tous-a-laventure-avec-sol-et-aero.e275a2beaf2a93b1cc940a75bfa31e9e.svg";
export { ForwardRef as ReactComponent };